import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createPortal } from "react-dom";
import Swal from "sweetalert2";
import "./BitacoraProduccion.css";
import {
  obtenerCatalogoMaguey,
  obtenerInstalacionesProduccion,
  obtenerCoccionesPorLogin,
  obtenerMoliendasPorLogin,
  obtenerDestilacionesPorLogin,
  obtenerTrazabilidadAsociado,
  registrarCoccion,
  actualizarCoccion,
  registrarMolienda,
  actualizarMolienda,
  registrarDestilacion,
  actualizarDestilacion,
  obtenerClasesPorLogin,
  registrarClaseAsociado,
  actualizarClaseAsociado,
  obtenerMaduracionPorLogin,
  registrarMaduracionAsociado,
  actualizarMaduracionAsociado,
  eliminarMaduracionAsociado,
  obtenerCondicionesPorLogin,
  registrarCondicionesAsociado,
  actualizarCondicionesAsociado,
  eliminarCondicionesAsociado,
  obtenerGranelesPorLogin,
  registrarGranel,
  registrarFusionGranel,
  deshacerMovimientoGranel,
  actualizarGranel,
  registrarTrasladoGranel,
  registrarDilucionGranel,
  registrarBajaGranel,
  registrarMuestreoGranel
} from "../../../redux/DucksBeneficiario/BitacoraProduccionDucks";

// Material UI Icons
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import ScienceIcon from '@mui/icons-material/Science';
import WineBarIcon from '@mui/icons-material/WineBar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GrassIcon from '@mui/icons-material/Grass';
import LayersIcon from '@mui/icons-material/Layers';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import TimelineIcon from '@mui/icons-material/Timeline';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import VerifiedIcon from '@mui/icons-material/Verified';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ModalDocumentosCoccion from './BitacoraProduccion/ModalDocumentosCoccion';
import { hostUI } from '../../../configuraciones';

// Subcomponents de cada Sección
import CoccionSection from "./BitacoraProduccion/CoccionSection";
import MoliendaSection from "./BitacoraProduccion/MoliendaSection";
import DestilacionSection, { extractKgAgaveCrudo, getMoliendaDestilacionBalance, createDestilacionItemsFromMolienda, extract1raDestilacionVolumes } from "./BitacoraProduccion/DestilacionSection";
import GranelSection from "./BitacoraProduccion/GranelSection";
import ElaboracionSection from "./BitacoraProduccion/ElaboracionSection";
import MaduracionSection from "./BitacoraProduccion/MaduracionSection";
import CondicionesSection from "./BitacoraProduccion/CondicionesSection";
import QuejasSection from "./BitacoraProduccion/QuejasSection";

// Lista de especies de maguey oficiales
const MAGUEY_SPECIES = [
  "Agave angustifolia Haw (Espadín)",
  "Agave potatorum Zucc (Tobalá)",
  "Agave americana L. (Arroqueño)",
  "Agave marmorata (Tepeztate)",
  "Agave rhodacantha (Mexicano)",
  "Agave karwinskii (Madrecuixe / Cuishe)",
  "Agave convallis (Jabalí)",
  "Agave seemanniana (Chiquilao)"
];

// Configuración de Tabs

// Registros de muestra para las secciones complementarias
const INITIAL_ELABORACION = [];

const INITIAL_MADURACION = [];

const INITIAL_CONDICIONES = [];

const INITIAL_QUEJAS = [
  {
    id: "QUEJA-01",
    fechaRecepcion: "2026-07-30",
    noLote: "PROD-2026-001",
    descripcionProducto: "Mezcal Artesanal - Joven / Blanco (Espadín)",
    tipoQueja: "Presentación / Sellado",
    nombreQuejoso: "Distribuidora Los Valles S.A. de C.V.",
    descripcionQueja: "Se reportó ligera fuga en tapón de muestra de lote.",
    accionesTomadas: "Se procedió al cambio de sello y revisión de lote.",
    estatusResolucion: "Resuelto",
    fechaResolucion: "2026-08-01",
    observaciones: "Queja atendida satisfactoriamente sin afectación a la calidad del mezcal.",
    status: "aprobado"
  }
];

// Configuración de Tabs
const TABS_CONFIG = [
  { id: 0, label: "Trazabilidad Integral", shortLabel: "Trazabilidad", icon: TimelineIcon },
  { id: 1, label: "Secc. II: Cocción", shortLabel: "Cocción", icon: LocalFireDepartmentIcon },
  { id: 2, label: "Secc. III (A): Molienda & Ferm.", shortLabel: "Molienda", icon: ScienceIcon },
  { id: 3, label: "Secc. III (B) & IV: Destilación", shortLabel: "Destilación", icon: WineBarIcon },
  { id: 4, label: "Secc. V: Granel", shortLabel: "Granel", icon: CheckCircleIcon },
  { id: 5, label: "Secc. VI: Clases & Reprocesos", shortLabel: "Reprocesos", icon: LayersIcon },
  { id: 6, label: "Secc. VII: Maduración", shortLabel: "Maduración", icon: HourglassBottomIcon },
  { id: 7, label: "Secc. VIII: Condiciones", shortLabel: "Condiciones", icon: DeviceThermostatIcon },
  { id: 8, label: "Secc. IX: Quejas", shortLabel: "Quejas", icon: ReportProblemIcon }
];

export const getCoccionMoliendaBalance = (coccion, moliendaRecords = [], currentMoliendaId = null) => {
  if (!coccion) return { totalKgCocidos: 0, kgUsados: 0, kgDisponibles: 0, isAgotada: true, pctConsumido: 0, moliendasCount: 0 };

  const totalKgCocidos = Number(
    String(coccion.kgMagueyCocido || coccion.kg_maguey_cocido || coccion.kgMaguey || coccion.kg_maguey || 0)
      .replace(/[^\d.]/g, '')
  ) || 0;

  const noProd = String(coccion.noProduccion || coccion.no_produccion || '').trim();
  const coccionId = String(coccion.rawId || coccion.id || coccion.id_bitacora_coccion || '').trim();

  const matchingMoliendas = (Array.isArray(moliendaRecords) ? moliendaRecords : []).filter(m => {
    if (currentMoliendaId && String(m.rawId || m.id || m.id_bitacora_molienda) === String(currentMoliendaId)) {
      return false;
    }
    const isCancelled = String(m.status || m.estatus || '').toLowerCase().includes('cancelad');
    if (isCancelled) return false;

    const mNoProd = String(m.noProduccion || m.no_produccion || '').trim();
    const mCoccionId = String(m.id_bitacora_coccion || m.idBitacoraCoccion || '').trim();

    return (noProd && mNoProd === noProd) || (coccionId && mCoccionId === coccionId);
  });

  const kgUsados = matchingMoliendas.reduce((acc, m) => {
    const items = Array.isArray(m.items) ? m.items : [];
    const moliendaKg = items.reduce((tAcc, it) => tAcc + (Number(String(it.kgMaguey || it.kg_maguey || 0).replace(/[^\d.]/g, '')) || 0), 0);
    const fallbackKg = Number(String(m.totalKgMaguey || m.total_kg_maguey || 0).replace(/[^\d.]/g, '')) || 0;
    return acc + (moliendaKg > 0 ? moliendaKg : fallbackKg);
  }, 0);

  const kgDisponibles = Math.max(0, totalKgCocidos - kgUsados);
  const isAgotada = totalKgCocidos > 0 ? (kgDisponibles <= 0) : false;
  const pctConsumido = totalKgCocidos > 0 ? Math.min(100, Math.round((kgUsados / totalKgCocidos) * 100)) : 0;

  return {
    totalKgCocidos,
    kgUsados,
    kgDisponibles,
    isAgotada,
    pctConsumido,
    moliendasCount: matchingMoliendas.length
  };
};

// =========================================================================
// REGLA: FORMATO DE MAGUEY: PRIMERO NOMBRE COMÚN, DESPUÉS CIENTÍFICO
// Ej: "Espadín (Agave angustifolia Haw)"
// =========================================================================
export const formatMagueyNombreComunPrimero = (magueyStr, catalog = []) => {
  if (!magueyStr || typeof magueyStr !== 'string') return "";
  const trimmed = magueyStr.trim();
  if (!trimmed) return "";

  // 1. Buscar coincidencia exacta o parcial en el catálogo
  const cleanTerm = trimmed.toLowerCase();
  const found = (Array.isArray(catalog) ? catalog : []).find(c => {
    const cComun = (c.nombre_comun || "").toLowerCase().trim();
    const cCient = (c.nombre_cientifico || "").toLowerCase().trim();
    return (cComun && cleanTerm.includes(cComun)) || (cCient && cleanTerm.includes(cCient));
  });

  if (found && found.nombre_comun && found.nombre_cientifico) {
    return `${found.nombre_comun} (${found.nombre_cientifico})`;
  }

  // 2. Si ya viene con paréntesis tipo "Agave... (Espadín)" o "Espadín (Agave...)"
  const match = trimmed.match(/^([^(]+)\s*\(([^)]+)\)$/);
  if (match) {
    const p1 = match[1].trim();
    const p2 = match[2].trim();
    if (p1.toLowerCase().includes("agave")) {
      return `${p2} (${p1})`;
    }
    return `${p1} (${p2})`;
  }

  return trimmed;
};

// =========================================================================
// REGLAS NOM-070-SCFI-2016: CÁLCULO DE CATEGORÍA DE MEZCAL SEGÚN EQUIPOS
// =========================================================================
export const calcularCategoriaMezcal = ({ tipoHorno, equipoMolienda, equipoFermentacion, tipoAlambique }) => {
  const norm = (s) => String(s || '').toLowerCase().trim();
  const horno = norm(tipoHorno);
  const molienda = norm(equipoMolienda);
  const fermentacion = norm(equipoFermentacion);
  const alambique = norm(tipoAlambique);

  // 1. Verificar si cae en Mezcal (Industrial): si CUALQUIER etapa usa equipo exclusivo de Mezcal
  const isIndustrial =
    horno.includes('autoclave') ||
    molienda.includes('tren de molinos') || molienda.includes('difusor') ||
    fermentacion.includes('acero inoxidable') ||
    alambique.includes('continuo') || alambique.includes('columna') || alambique === 'alambique';

  if (isIndustrial) {
    return 'Mezcal';
  }

  // 2. Verificar si califica para Mezcal Ancestral (TODAS las 4 etapas deben cumplir con equipo ancestral)
  // Cocción Ancestral: Horno de pozo
  const isCoccionAncestral = horno.includes('pozo') || !horno;

  // Molienda Ancestral: Mazo de madera o Tahona (chileno / egipcio)
  const isMoliendaAncestral =
    molienda.includes('mazo') || molienda.includes('tahona') || molienda.includes('chileno') || molienda.includes('egipcio') || !molienda;

  // Fermentación Ancestral: piedra, suelo, tronco, pieles, barro, madera, piletas mampostería
  const isFermentacionAncestral =
    fermentacion.includes('piedra') || fermentacion.includes('suelo') || fermentacion.includes('tronco') ||
    fermentacion.includes('piel') || fermentacion.includes('barro') || fermentacion.includes('madera') ||
    fermentacion.includes('mamposter') || !fermentacion;

  // Destilación Ancestral: Olla de barro con montera de barro o madera
  const isDestilacionAncestral = alambique.includes('olla de barro') || alambique.includes('barro');

  if (isCoccionAncestral && isMoliendaAncestral && isFermentacionAncestral && isDestilacionAncestral) {
    return 'Mezcal Ancestral';
  }

  // 3. Por omisión: Cumple con los requisitos de Mezcal Artesanal
  return 'Mezcal Artesanal';
};

const BitacoraProduccion = () => {
  const dispatch = useDispatch();

  // Pestaña activa: 0 (Trazabilidad) o 1-8 (Secciones individuales)
  const [activeTab, setActiveTab] = useState(0);

  // Obtener usuario autenticado e id_login (id: 3462)
  const usuarioData = useSelector(state => state.Usuario?.data || state.Usuario || null);
  const idLogin = usuarioData?.user?.[0]?.id ||
    usuarioData?.user?.id ||
    usuarioData?.idlogin ||
    usuarioData?.id_login ||
    usuarioData?.id ||
    null;

  // Filtros y Búsqueda para la tabla única de Trazabilidad
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStageFilter, setSelectedStageFilter] = useState("todas");
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("todos");
  const [tracePage, setTracePage] = useState(1);
  const [traceLimit, setTraceLimit] = useState(10);
  const reduxTrazabilidadPagination = useSelector(state => state.bitacoraProduccion?.trazabilidadPagination || { total: 0, page: 1, limit: 10, totalPages: 1 });

  // Filtros y Búsqueda para la Sección de Cocción
  const [coccionSearch, setCoccionSearch] = useState("");
  const [coccionStatusFilter, setCoccionStatusFilter] = useState("todos");
  const [coccionPage, setCoccionPage] = useState(1);
  const [coccionLimit, setCoccionLimit] = useState(10);
  const reduxCoccionPagination = useSelector(state => state.bitacoraProduccion?.coccionPagination || { total: 0, page: 1, limit: 10, totalPages: 1 });

  // Cargar instalaciones y registros iniciales al montar o cambiar usuario
  useEffect(() => {
    dispatch(obtenerCatalogoMaguey());
    if (idLogin) {
      dispatch(obtenerInstalacionesProduccion(idLogin));
      dispatch(obtenerGranelesPorLogin(idLogin));
      dispatch(obtenerMaduracionPorLogin(idLogin));
      dispatch(obtenerCondicionesPorLogin(idLogin));
      dispatch(obtenerClasesPorLogin(idLogin));
    }
  }, [dispatch, idLogin]);

  // Cargar información específica según la pestaña activa (Trazabilidad o Cocción) con debounce
  useEffect(() => {
    if (!idLogin) return;

    const timer = setTimeout(() => {
      if (activeTab === 0) {
        // Pestaña 0: Trazabilidad Integral
        dispatch(obtenerTrazabilidadAsociado({
          id_login: idLogin,
          page: tracePage,
          limit: traceLimit,
          search: searchTerm,
          estatus: selectedStatusFilter
        }));
      } else if (activeTab === 1) {
        // Pestaña 1: Secc. II Cocción
        dispatch(obtenerCoccionesPorLogin({
          id_login: idLogin,
          page: coccionPage,
          limit: coccionLimit,
          search: coccionSearch,
          estatus: coccionStatusFilter
        }));
      } else if (activeTab === 2) {
        // Pestaña 2: Secc. III Molienda
        dispatch(obtenerMoliendasPorLogin(idLogin));
      } else if (activeTab === 3) {
        // Pestaña 3: Secc. IV Destilación
        dispatch(obtenerDestilacionesPorLogin(idLogin));
        dispatch(obtenerMoliendasPorLogin(idLogin));
        dispatch(obtenerCoccionesPorLogin({ id_login: idLogin, page: 1, limit: 50 }));
      } else if (activeTab === 4) {
        // Pestaña 4: Secc. V Granel
        dispatch(obtenerGranelesPorLogin(idLogin));
      } else if (activeTab === 5) {
        // Pestaña 5: Secc. VI Clases y Reprocesos
        dispatch(obtenerClasesPorLogin(idLogin));
      } else if (activeTab === 6) {
        // Pestaña 6: Secc. VII Maduración
        dispatch(obtenerMaduracionPorLogin(idLogin));
      } else if (activeTab === 7) {
        // Pestaña 7: Secc. VIII Condiciones Ambientales
        dispatch(obtenerCondicionesPorLogin(idLogin));
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [
    dispatch,
    idLogin,
    activeTab,
    tracePage,
    traceLimit,
    searchTerm,
    selectedStatusFilter,
    coccionPage,
    coccionLimit,
    coccionSearch,
    coccionStatusFilter
  ]);

  // Obtener todas las instalaciones del socio desde Redux (Bitácora de Producción + módulos de soporte)
  const reduxBitacoraInst = useSelector(state => state.bitacoraProduccion?.instalaciones || []);
  const reduxFC36Inst = useSelector(state => state.FC_36Beneficiario?.instalacionesCliente || []);
  const reduxFC35Inst = useSelector(state => state.FC_35Beneficiario?.instalacionesCliente || []);
  const reduxSolicitudesInst = useSelector(state => state.Solicitudes?.instalacionesCliente || []);
  const reduxInstalacionInst = useSelector(state => state.Instalacion?.instalacionesCliente || []);

  const reduxTrazabilidadLots = useSelector(state => state.bitacoraProduccion?.trazabilidadLots || []);

  const availableInstalaciones = useMemo(() => {
    const list = [
      ...(Array.isArray(reduxBitacoraInst) ? reduxBitacoraInst : []),
      ...(Array.isArray(reduxFC36Inst) ? reduxFC36Inst : []),
      ...(Array.isArray(reduxFC35Inst) ? reduxFC35Inst : []),
      ...(Array.isArray(reduxSolicitudesInst) ? reduxSolicitudesInst : []),
      ...(Array.isArray(reduxInstalacionInst) ? reduxInstalacionInst : [])
    ];

    const map = new Map();
    list.forEach(item => {
      if (!item) return;
      const idAnexo = item.idanexocliente || item.id_anexo_cliente || item.id || item.id_unidad_produccion;
      if (!idAnexo || map.has(String(idAnexo))) return;

      const infoGen = item.informaciongeneralinstalacioncliente || item;
      const alias = infoGen?.alias || item.alias || `Instalación #${idAnexo}`;
      const tipo = item.tipo || infoGen?.tipo || (item.idtipoanexo === 1 ? 'Unidad de producción' : item.idtipoanexo === 2 ? 'Unidad de envasado' : item.idtipoanexo === 3 ? 'Unidad de almacén' : 'Instalación');

      let dir = infoGen?.direccion || item.direccion;
      if (!dir && infoGen) {
        dir = [
          infoGen.calle,
          infoGen.numeroexterior || infoGen.numext,
          infoGen.colonia,
          infoGen.municipio,
          infoGen.estado
        ].filter(Boolean).join(", ");
      }
      dir = dir || "Domicilio registrado";

      map.set(String(idAnexo), {
        ...item,
        idanexocliente: idAnexo,
        id: idAnexo,
        alias: alias,
        direccion: dir,
        tipo: tipo,
        idtipoanexo: item.idtipoanexo || (tipo.toLowerCase().includes("envasado") ? 2 : tipo.toLowerCase().includes("almac") ? 3 : 1),
        informaciongeneralinstalacioncliente: {
          ...infoGen,
          alias: alias,
          direccion: dir,
          tipo: tipo
        }
      });
    });

    return Array.from(map.values());
  }, [reduxBitacoraInst, reduxFC36Inst, reduxFC35Inst, reduxSolicitudesInst, reduxInstalacionInst]);

  // Estado maestro con todos los lotes y su trazabilidad
  const [productionLots, setProductionLots] = useState([]);

  // Sincronizar lotes de trazabilidad traídos desde el backend para el asociado
  useEffect(() => {
    if (Array.isArray(reduxTrazabilidadLots) && reduxTrazabilidadLots.length > 0) {
      setProductionLots(reduxTrazabilidadLots);
    }
  }, [reduxTrazabilidadLots]);

  // Estados independientes de cada sección para compatibilidad total de tabs
  const [elaboracionRecords, setElaboracionRecords] = useState(INITIAL_ELABORACION);
  const [maduracionRecords, setMaduracionRecords] = useState([]);
  const [condicionesRecords, setCondicionesRecords] = useState([]);
  const [quejasRecords, setQuejasRecords] = useState(INITIAL_QUEJAS);
  const [customGranelRecords, setCustomGranelRecords] = useState([]);

  // Estados de formularios de subcomponentes
  const [isSectionFormOpen, setIsSectionFormOpen] = useState(false);
  const [formSectionData, setFormSectionData] = useState({});

  // Modales interactivos del flujo de Trazabilidad
  const [activeModal, setActiveModal] = useState(null); // 'coccion' | 'molienda' | 'destilacion' | 'granel' | 'trazabilidad'
  const [selectedLot, setSelectedLot] = useState(null);

  // Registros de Cocción, Molienda y Destilación obtenidos de Redux / BackendInspeccion
  const reduxCoccionRecords = useSelector(state => state.bitacoraProduccion?.coccionRecords || []);
  const reduxMoliendaRecords = useSelector(state => state.bitacoraProduccion?.moliendaRecords || []);
  const reduxDestilacionRecords = useSelector(state => state.bitacoraProduccion?.destilacionRecords || []);
  const reduxClasesRecords = useSelector(state => state.bitacoraProduccion?.clasesRecords || []);
  const catalogoMaguey = useSelector(state => state.bitacoraProduccion?.catalogoMaguey || []);

  const reduxMaduracionRecords = useSelector(state => state.bitacoraProduccion?.maduracionRecords || []);
  const reduxCondicionesRecords = useSelector(state => state.bitacoraProduccion?.condicionesRecords || []);
  const reduxGranelRecords = useSelector(state => state.bitacoraProduccion?.granelRecords || []);
  const reduxGranelPagination = useSelector(state => state.bitacoraProduccion?.granelPagination || { total: 0, page: 1, limit: 10, totalPages: 1 });

  // Sincronizar registros de clases con Redux
  useEffect(() => {
    if (Array.isArray(reduxClasesRecords)) {
      setElaboracionRecords(reduxClasesRecords);
    }
  }, [reduxClasesRecords]);

  // Sincronizar registros de maduración con Redux
  useEffect(() => {
    if (Array.isArray(reduxMaduracionRecords)) {
      setMaduracionRecords(reduxMaduracionRecords);
    }
  }, [reduxMaduracionRecords]);

  // Sincronizar registros de condiciones ambientales con Redux
  useEffect(() => {
    if (Array.isArray(reduxCondicionesRecords)) {
      setCondicionesRecords(reduxCondicionesRecords);
    }
  }, [reduxCondicionesRecords]);

  const effectiveMaduracionRecords = useMemo(() => {
    if (Array.isArray(reduxMaduracionRecords) && reduxMaduracionRecords.length > 0) {
      return reduxMaduracionRecords;
    }
    return maduracionRecords;
  }, [reduxMaduracionRecords, maduracionRecords]);
  console.log("effectiveMaduracionRecords", effectiveMaduracionRecords);

  const effectiveCondicionesRecords = useMemo(() => {
    if (Array.isArray(reduxCondicionesRecords) && reduxCondicionesRecords.length > 0) {
      return reduxCondicionesRecords;
    }
    return condicionesRecords;
  }, [reduxCondicionesRecords, condicionesRecords]);

  // Cómputo de Lotes Efectivos (Prioriza registros reales traídos del backend para el asociado)
  const effectiveLots = useMemo(() => {
    const sourceData = (Array.isArray(reduxTrazabilidadLots) && reduxTrazabilidadLots.length > 0)
      ? reduxTrazabilidadLots
      : (Array.isArray(reduxCoccionRecords) && reduxCoccionRecords.length > 0)
        ? reduxCoccionRecords
        : null;

    if (!sourceData) {
      if (Array.isArray(productionLots) && productionLots.length > 0) {
        return productionLots;
      }
      return [];
    }

    return sourceData.map(item => {
      const rawKgCrudo = Number(String(item.kg_maguey || item.kgMaguey || item.kgMagueyCrudo || item.coccion?.kgMagueyCrudo || 0).replace(/[^\d.]/g, ''));
      const rawKgCocido = Number(String(item.kg_maguey_cocido || item.kgMagueyCocido || item.coccion?.kgMagueyCocido || 0).replace(/[^\d.]/g, ''));

      const targetIdInst = item.id_unidad_produccion || item.idUnidadProduccion;
      const foundInst = availableInstalaciones.find(i => String(i.idanexocliente || i.id) === String(targetIdInst));
      const aliasInst = item.unidadProduccion || item.alias_instalacion || foundInst?.informaciongeneralinstalacioncliente?.alias || foundInst?.alias || (targetIdInst ? `Unidad #${targetIdInst}` : "Unidad de Producción");

      const noProd = item.no_produccion || item.noProduccion || `PROD-${item.id_bitacora_coccion || item.id}`;

      // Cruzar con Moliendas y Destilaciones cargadas en Redux
      const moliendaFromRedux = (Array.isArray(reduxMoliendaRecords) ? reduxMoliendaRecords : []).find(
        m => (m.no_produccion && m.no_produccion === noProd) || (m.noProduccion && m.noProduccion === noProd)
      );

      const destilacionFromRedux = (Array.isArray(reduxDestilacionRecords) ? reduxDestilacionRecords : []).find(
        d => (d.no_produccion && d.no_produccion === noProd) || (d.noProduccion && d.noProduccion === noProd)
      );

      const resolvedMolienda = item.molienda || (moliendaFromRedux ? {
        id: moliendaFromRedux.id_bitacora_molienda || moliendaFromRedux.id,
        id_bitacora_molienda: moliendaFromRedux.id_bitacora_molienda || moliendaFromRedux.id,
        noProduccion: moliendaFromRedux.no_produccion || moliendaFromRedux.noProduccion,
        observaciones: moliendaFromRedux.observaciones || "",
        statusUI: moliendaFromRedux.statusUI || moliendaFromRedux.estatus || "enviada",
        status: moliendaFromRedux.estatus || moliendaFromRedux.status || "enviada",
        estatus: moliendaFromRedux.estatus || moliendaFromRedux.status || "enviada",
        inspector: moliendaFromRedux.inspector || "Pendiente de V.Bo.",
        observacionesInspector: moliendaFromRedux.observaciones_correccion || moliendaFromRedux.observacionesInspector || "",
        totalKgMaguey: moliendaFromRedux.totalKgMaguey || 0,
        totalVolFormulado: moliendaFromRedux.totalVolFormulado || 0,
        totalVolOrdinario: moliendaFromRedux.totalVolMezcal || moliendaFromRedux.totalVolOrdinario || 0,
        totalVolMezcal: moliendaFromRedux.totalVolMezcal || moliendaFromRedux.totalVolOrdinario || 0,
        totalVolColas: moliendaFromRedux.totalVolColas || 0,
        items: moliendaFromRedux.items || []
      } : null);

      const resolvedDestilacion = item.destilacion || (destilacionFromRedux ? {
        id: destilacionFromRedux.id_bitacora_destilacion || destilacionFromRedux.id,
        id_bitacora_destilacion: destilacionFromRedux.id_bitacora_destilacion || destilacionFromRedux.id,
        noProduccion: destilacionFromRedux.no_produccion || destilacionFromRedux.noProduccion,
        tipoAlambique: destilacionFromRedux.tipoAlambique || "",
        totalVolCargado: destilacionFromRedux.totalVolCargado || destilacionFromRedux.volADestilar || 0,
        totalPuntas: destilacionFromRedux.totalPuntas || 0,
        totalMezcalObtenido: destilacionFromRedux.totalMezcalObtenido || destilacionFromRedux.mezcal || 0,
        avgAlcMezcal: destilacionFromRedux.avgAlcMezcal || destilacionFromRedux.pctAlcMezcal || 0,
        totalColas: destilacionFromRedux.totalColas || 0,
        esDestiladoCon: destilacionFromRedux.esDestiladoCon || false,
        destiladoConIngrediente: destilacionFromRedux.destiladoConIngrediente || "",
        observaciones: destilacionFromRedux.observaciones || "",
        statusUI: destilacionFromRedux.statusUI || destilacionFromRedux.estatus || "enviada",
        status: destilacionFromRedux.estatus || destilacionFromRedux.status || "enviada",
        estatus: destilacionFromRedux.estatus || destilacionFromRedux.status || "enviada",
        inspector: destilacionFromRedux.inspector || "Pendiente de V.Bo.",
        observacionesInspector: destilacionFromRedux.observaciones_correccion || destilacionFromRedux.observacionesInspector || "",
        items: destilacionFromRedux.items || []
      } : null);

      let etapaActual = "coccion";
      if (item.granel) {
        etapaActual = "granel";
      } else if (resolvedDestilacion) {
        etapaActual = "destilacion";
      } else if (resolvedMolienda) {
        etapaActual = "molienda";
      }

      const activePhase = item.granel || resolvedDestilacion || resolvedMolienda || item.coccion || item;
      const rawEstatus = (activePhase.estatus || activePhase.status || activePhase.statusUI || item.estatus || item.status || item.statusUI || "enviada").toLowerCase();
      let statusUI = "nueva";
      if (rawEstatus === "aceptada" || rawEstatus === "aprobado" || rawEstatus === "aceptado" || rawEstatus === "aprobado_ui") {
        statusUI = "aprobado";
      } else if (rawEstatus === "rechazada" || rawEstatus === "rechazado" || rawEstatus === "rechazado_ui") {
        statusUI = "rechazado";
      } else if (rawEstatus === "en_revision" || rawEstatus === "revision") {
        statusUI = "revision";
      } else if (rawEstatus === "cancelada" || rawEstatus === "cancelado") {
        statusUI = "cancelado";
      } else if (rawEstatus === "borrador") {
        statusUI = "borrador";
      } else {
        statusUI = "enviada";
      }

      const resolvedInspectorName =
        (activePhase.inspector && !activePhase.inspector.includes("Pendiente") && !activePhase.inspector.includes("Sin asignar"))
          ? activePhase.inspector
          : (item.inspector || item.nombre_inspector || item.inspector_nombre || item.vbo_inspector || (item.id_inspector ? `Inspector #${item.id_inspector}` : "Pendiente de V.Bo."));

      const resolvedObs = activePhase.observaciones_correccion || activePhase.observacionesInspector || item.observaciones_correccion || item.observacionesInspector || "";

      const rawMagueyes = (Array.isArray(item.magueyes) && item.magueyes.length > 0)
        ? item.magueyes
        : (Array.isArray(item.coccion?.magueyes) && item.coccion.magueyes.length > 0)
          ? item.coccion.magueyes
          : (item.tipo_maguey || item.tipoMaguey)
            ? [{
              id: 1,
              tipoMaguey: item.tipo_maguey || item.tipoMaguey,
              numPinas: Number(item.num_pinas || item.numPinas || 0),
              kgMaguey: rawKgCrudo
            }]
            : [];

      return {
        id: noProd,
        dbId: item.id_bitacora_coccion || item.id || item.dbId,
        id_bitacora_coccion: item.id_bitacora_coccion || (typeof item.id === 'number' ? item.id : null) || (typeof item.dbId === 'number' ? item.dbId : null),
        noProduccion: noProd,
        no_produccion: noProd,
        idUnidadProduccion: targetIdInst,
        unidadProduccion: aliasInst,
        predio: (item.guia_predio && item.guia_predio.trim()) || (item.guiaPredio && item.guiaPredio.trim()) || item.predio || "Predio Registrado",
        tipoMaguey: item.tipo_maguey || item.tipoMaguey || "Agave angustifolia Haw (Espadín)",
        magueyes: rawMagueyes,
        etapaActual: etapaActual,
        statusUI: statusUI,
        status: activePhase.estatus || activePhase.status || item.estatus || item.status || "enviada",
        estatus: activePhase.estatus || activePhase.status || item.estatus || item.status || "enviada",
        fechaInicio: item.fecha_ingreso || item.fechaIngreso || item.fechaInicio || "",
        fechaActualizacion: item.fecha_actualizacion || item.fechaActualizacion || item.fecha_ingreso || "",
        inspector: resolvedInspectorName,
        observacionesInspector: resolvedObs,
        observaciones_correccion: resolvedObs,
        tiene_guia_maguey: Boolean(item.tiene_guia_maguey || item.doc_guia_maguey || item.documentosMap?.guia_maguey || item.coccion?.tiene_guia_maguey),
        tiene_informe_art: Boolean(item.tiene_informe_art || item.doc_informe_art || item.documentosMap?.informe_art || item.coccion?.tiene_informe_art),
        doc_guia_maguey: item.doc_guia_maguey || item.documentosMap?.guia_maguey || null,
        doc_informe_art: item.doc_informe_art || item.documentosMap?.informe_art || null,
        documentos: item.documentos || [],
        documentosMap: item.documentosMap || null,
        coccion: item.coccion || {
          numPinas: Number(item.num_pinas || item.numPinas || 0),
          kgMagueyCrudo: rawKgCrudo,
          magueyes: rawMagueyes,
          fechaIngreso: item.fecha_ingreso || item.fechaIngreso || "",
          guiaPredio: (item.guia_predio && item.guia_predio.trim()) || (item.guiaPredio && item.guiaPredio.trim()) || "",
          pctArt: item.pct_art != null ? item.pct_art : item.pctArt,
          noInforme: item.no_informe || item.noInforme || "",
          tipoHorno: item.tipo_horno || item.tipoHorno || "",
          fechaInicioCoccion: item.fecha_inicio_coccion || item.fechaInicioCoccion || "",
          fechaFinCoccion: item.fecha_fin_coccion || item.fechaFinCoccion || "",
          kgMagueyCocido: rawKgCocido,
          observaciones: item.observaciones || ""
        },
        molienda: resolvedMolienda,
        destilacion: resolvedDestilacion,
        granel: item.granel || null
      };
    });
  }, [reduxTrazabilidadLots, reduxCoccionRecords, reduxMoliendaRecords, reduxDestilacionRecords, productionLots, availableInstalaciones]);

  // Filtrado y cómputo de la tabla de trazabilidad
  const filteredLots = useMemo(() => {
    return effectiveLots.filter(lot => {
      const term = searchTerm.toLowerCase();
      const matchSearch =
        (lot.noProduccion && lot.noProduccion.toLowerCase().includes(term)) ||
        (lot.tipoMaguey && lot.tipoMaguey.toLowerCase().includes(term)) ||
        (lot.predio && lot.predio.toLowerCase().includes(term)) ||
        (lot.inspector && lot.inspector.toLowerCase().includes(term));

      const matchStage = selectedStageFilter === "todas" || lot.etapaActual === selectedStageFilter;

      let matchStatus = true;
      if (selectedStatusFilter !== "todos") {
        if (selectedStatusFilter === "aprobado" || selectedStatusFilter === "aprobado_ui" || selectedStatusFilter === "aceptada") {
          matchStatus = lot.statusUI === "aprobado" || lot.statusUI === "aprobado_ui" || lot.status === "aceptada";
        } else if (selectedStatusFilter === "rechazado" || selectedStatusFilter === "rechazada") {
          matchStatus = lot.statusUI === "rechazado" || lot.status === "rechazada";
        } else if (selectedStatusFilter === "revision" || selectedStatusFilter === "enviada" || selectedStatusFilter === "pendiente_ui") {
          matchStatus = lot.statusUI === "revision" || lot.statusUI === "enviada" || lot.statusUI === "nueva" || lot.status === "enviada";
        } else if (selectedStatusFilter === "borrador") {
          matchStatus = lot.statusUI === "borrador" || lot.status === "borrador";
        } else if (selectedStatusFilter === "cancelado" || selectedStatusFilter === "cancelada") {
          matchStatus = lot.statusUI === "cancelado" || lot.status === "cancelada";
        } else {
          matchStatus = lot.statusUI === selectedStatusFilter;
        }
      }

      return matchSearch && matchStage && matchStatus;
    });
  }, [effectiveLots, searchTerm, selectedStageFilter, selectedStatusFilter]);

  // Registros mapeados para subcomponentes individuales (100% sincronizados con Cocción y Trazabilidad)
  const coccionSectionRecords = useMemo(() => {
    const sourceList = (Array.isArray(reduxCoccionRecords) && reduxCoccionRecords.length > 0)
      ? reduxCoccionRecords
      : (Array.isArray(effectiveLots) ? effectiveLots.filter(l => l.coccion) : []);

    return sourceList.map(item => {
      let rawKgCrudo = 0;
      if (Array.isArray(item.magueyes) && item.magueyes.length > 0) {
        rawKgCrudo = item.magueyes.reduce((acc, m) => acc + (Number(String(m.kgMaguey || m.kg_maguey || 0).replace(/,/g, '').replace(/[^\d.]/g, '')) || 0), 0);
      } else if (Array.isArray(item.coccion?.magueyes) && item.coccion.magueyes.length > 0) {
        rawKgCrudo = item.coccion.magueyes.reduce((acc, m) => acc + (Number(String(m.kgMaguey || m.kg_maguey || 0).replace(/,/g, '').replace(/[^\d.]/g, '')) || 0), 0);
      }
      if (!rawKgCrudo) {
        rawKgCrudo = Number(String(item.kg_maguey_crudo || item.kg_maguey || item.kgMaguey || item.kgMagueyCrudo || item.coccion?.kgMagueyCrudo || item.coccion?.kg_maguey || item.coccion?.kg_maguey_crudo || 0).replace(/[^\d.]/g, ''));
      }
      const rawKgCocido = Number(String(item.kg_maguey_cocido || item.kgMagueyCocido || item.coccion?.kgMagueyCocido || 0).replace(/[^\d.]/g, ''));
      const numPinas = Number(item.num_pinas || item.numPinas || item.pinas || item.coccion?.numPinas || 0);

      const targetIdInst = item.id_unidad_produccion || item.idUnidadProduccion || item.coccion?.idUnidadProduccion || "";
      const foundInst = availableInstalaciones.find(i => String(i.idanexocliente || i.id) === String(targetIdInst));
      const aliasInst = item.unidadProduccion || item.alias_instalacion || foundInst?.informaciongeneralinstalacioncliente?.alias || foundInst?.alias || (targetIdInst ? `Unidad #${targetIdInst}` : "-");

      const resolvedInspectorName =
        item.inspector ||
        item.nombre_inspector ||
        item.inspector_nombre ||
        item.vbo_inspector ||
        item.inspector_asignado ||
        (item.inspector_info?.nombre_completo) ||
        (item.id_inspector ? `Inspector #${item.id_inspector}` : "Pendiente de V.Bo.");

      const rawEstatus = (item.estatus || item.status || item.statusUI || "borrador").toLowerCase();

      const parsedMagueyes = (Array.isArray(item.magueyes) && item.magueyes.length > 0)
        ? item.magueyes
        : (Array.isArray(item.coccion?.magueyes) && item.coccion.magueyes.length > 0)
          ? item.coccion.magueyes
          : (item.tipo_maguey || item.tipoMaguey || item.coccion?.tipoMaguey)
            ? [{
              id: 1,
              tipoMaguey: item.tipo_maguey || item.tipoMaguey || item.coccion?.tipoMaguey,
              numPinas: numPinas,
              kgMaguey: rawKgCrudo
            }]
            : [];

      return {
        id: item.no_produccion || item.noProduccion || `PROD-${item.id_bitacora_coccion || item.id || item.dbId}`,
        rawId: item.id_bitacora_coccion || item.id || item.dbId,
        idBitacoraCoccion: item.id_bitacora_coccion || item.id || item.dbId,
        id_bitacora_coccion: item.id_bitacora_coccion || item.rawId || item.idBitacoraCoccion || item.dbId || (typeof item.id === "number" ? item.id : null),
        idUnidadProduccion: targetIdInst,
        unidadProduccion: aliasInst,
        noProduccion: item.no_produccion || item.noProduccion || "",
        magueyes: parsedMagueyes,
        pinas: numPinas,
        numPinas: numPinas,
        kgMaguey: `${rawKgCrudo.toLocaleString()} kg`,
        kgMagueyCrudo: rawKgCrudo,
        fechaIngreso: item.fecha_ingreso || item.fechaIngreso || item.coccion?.fechaIngreso || "",
        guiaPredio: (item.guia_predio && item.guia_predio.trim()) || (item.guiaPredio && item.guiaPredio.trim()) || (item.coccion?.guiaPredio && item.coccion?.guiaPredio.trim()) || item.predio || "",
        tipoMaguey: item.tipo_maguey || item.tipoMaguey || item.coccion?.tipoMaguey || "Agave angustifolia Haw (Espadín)",
        pctArt: (item.pct_art != null ? item.pct_art : (item.pctArt != null ? item.pctArt : (item.coccion?.pctArt != null ? item.coccion?.pctArt : null))) != null
          ? `${item.pct_art ?? item.pctArt ?? item.coccion?.pctArt}%`
          : '-',
        noInforme: item.no_informe || item.noInforme || item.coccion?.noInforme || "",
        tipoHorno: item.tipo_horno || item.tipoHorno || item.coccion?.tipoHorno || "",
        fechaInicioCoccion: item.fecha_inicio_coccion || item.fechaInicioCoccion || item.coccion?.fechaInicioCoccion || item.fecha_ingreso || item.fechaIngreso || "",
        fechaFinCoccion: item.fecha_fin_coccion || item.fechaFinCoccion || item.coccion?.fechaFinCoccion || item.fecha_ingreso || item.fechaIngreso || "",
        kgMagueyCocido: `${rawKgCocido.toLocaleString()} kg`,
        observaciones: item.observaciones || item.coccion?.observaciones || "",
        inspector: resolvedInspectorName,
        status: rawEstatus,
        statusUI: item.statusUI || rawEstatus,
        observacionesCorreccion: item.observaciones_correccion || item.observacionesCorreccion || item.observacionesInspector || ""
      };
    });
  }, [reduxCoccionRecords, effectiveLots, availableInstalaciones]);

  const moliendaSectionRecords = useMemo(() => {
    const parseTinaVol = (val) => {
      if (val == null || val === '') return 0;
      if (typeof val === 'number') return isNaN(val) ? 0 : val;
      const cleaned = String(val).replace(/,/g, '').replace(/[^\d.]/g, '');
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    };

    if (Array.isArray(reduxMoliendaRecords) && reduxMoliendaRecords.length > 0) {
      return reduxMoliendaRecords.map(r => {
        const foundCoccion = (Array.isArray(coccionSectionRecords) ? coccionSectionRecords : []).find(c =>
          (r.id_bitacora_coccion && (String(c.rawId) === String(r.id_bitacora_coccion) || String(c.idBitacoraCoccion) === String(r.id_bitacora_coccion))) ||
          ((r.no_produccion || r.noProduccion) && (c.noProduccion === (r.no_produccion || r.noProduccion) || c.id === (r.no_produccion || r.noProduccion)))
        ) || r.coccion || r.bitacora_coccion || null;

        const rawTinas = (Array.isArray(r.items) && r.items.length > 0 ? r.items : null) ||
          (Array.isArray(r.tinas) && r.tinas.length > 0 ? r.tinas : null) ||
          (Array.isArray(r.bitacora_produccion_molienda_detalle) && r.bitacora_produccion_molienda_detalle.length > 0 ? r.bitacora_produccion_molienda_detalle : null) ||
          (Array.isArray(r.tinas_desglose) && r.tinas_desglose.length > 0 ? r.tinas_desglose : null) ||
          (Array.isArray(r.detalles) && r.detalles.length > 0 ? r.detalles : null) ||
          (Array.isArray(r.molienda_detalle) && r.molienda_detalle.length > 0 ? r.molienda_detalle : []) ||
          [];

        const formattedItems = rawTinas.map((it, idx) => {
          const rawKg = parseTinaVol(it.kgMaguey || it.kg_maguey);
          const rawVForm = parseTinaVol(it.volumenFormulado || it.volumen_formulado);
          const rawVOrd = Math.max(
            parseTinaVol(it.volumenOrdinario),
            parseTinaVol(it.volumen_ordinario),
            parseTinaVol(it.volumenMezcal),
            parseTinaVol(it.volumen_mezcal),
            parseTinaVol(it.volOrd),
            parseTinaVol(it.vol_ord)
          );
          const rawVCol = Math.max(
            parseTinaVol(it.volumenColas),
            parseTinaVol(it.volumen_colas),
            parseTinaVol(it.volCol),
            parseTinaVol(it.vol_col)
          );
          const rawPAlcOrd = parseTinaVol(it.pctAlcOrdinario || it.pct_alc_mezcal || it.pctAlcMezcal);
          const rawPAlcCol = parseTinaVol(it.pctAlcColas || it.pct_alc_colas);

          const tinaSum1ra = (rawVOrd + rawVCol) > 0 ? (rawVOrd + rawVCol) : parseTinaVol(it.volumen || it.volumen_1ra || it.totalVol);

          return {
            ...it,
            id: it.id || it.id_molienda_detalle || (idx + 1),
            noProceso: it.noProceso || it.no_proceso || (idx + 1),
            contenedor: it.contenedor || `Tina ${idx + 1 < 10 ? '0' + (idx + 1) : idx + 1}`,
            kgMaguey: typeof it.kgMaguey === 'number' ? `${it.kgMaguey.toLocaleString()} kg` : (it.kgMaguey || (rawKg > 0 ? `${rawKg.toLocaleString()} kg` : "0 kg")),
            volumenFormulado: typeof it.volumenFormulado === 'number' ? `${it.volumenFormulado.toLocaleString()} L` : (it.volumenFormulado || (rawVForm > 0 ? `${rawVForm.toLocaleString()} L` : "0 L")),
            volumenOrdinario: typeof it.volumenOrdinario === 'number' ? `${it.volumenOrdinario.toLocaleString()} L` : (it.volumenOrdinario || it.volumenMezcal || (rawVOrd > 0 ? `${rawVOrd.toLocaleString()} L` : "0 L")),
            volumenMezcal: typeof it.volumenMezcal === 'number' ? `${it.volumenMezcal.toLocaleString()} L` : (it.volumenOrdinario || it.volumenMezcal || (rawVOrd > 0 ? `${rawVOrd.toLocaleString()} L` : "0 L")),
            pctAlcOrdinario: typeof it.pctAlcOrdinario === 'number' ? `${it.pctAlcOrdinario}%` : (it.pctAlcOrdinario || it.pctAlcMezcal || (rawPAlcOrd > 0 ? `${rawPAlcOrd}%` : "0%")),
            pctAlcMezcal: typeof it.pctAlcMezcal === 'number' ? `${it.pctAlcMezcal}%` : (it.pctAlcOrdinario || it.pctAlcMezcal || (rawPAlcOrd > 0 ? `${rawPAlcOrd}%` : "0%")),
            volumenColas: typeof it.volumenColas === 'number' ? `${it.volumenColas.toLocaleString()} L` : (it.volumenColas || (rawVCol > 0 ? `${rawVCol.toLocaleString()} L` : "0 L")),
            pctAlcColas: typeof it.pctAlcColas === 'number' ? `${it.pctAlcColas}%` : (it.pctAlcColas || (rawPAlcCol > 0 ? `${rawPAlcCol}%` : "0%")),
            // Propiedades numéricas directas para cálculos
            rawKgMaguey: rawKg,
            rawVolumenFormulado: rawVForm,
            rawVolumenOrdinario: rawVOrd,
            rawVolumenMezcal: rawVOrd,
            rawVolumenColas: rawVCol,
            rawPctAlcOrdinario: rawPAlcOrd,
            rawPctAlcColas: rawPAlcCol,
            totalTina1raDestilacion: tinaSum1ra
          };
        });

        const sumTinas = formattedItems.reduce((acc, it) => acc + (it.totalTina1raDestilacion || (it.rawVolumenOrdinario + it.rawVolumenColas)), 0);
        const rootOrd = Math.max(
          parseTinaVol(r.totalVolOrdinario),
          parseTinaVol(r.total_vol_ordinario),
          parseTinaVol(r.total_volumen_ordinario),
          parseTinaVol(r.totalVolMezcal),
          parseTinaVol(r.total_vol_mezcal),
          parseTinaVol(r.total_volumen_mezcal),
          parseTinaVol(r.volumenMezcal),
          parseTinaVol(r.volumenOrdinario)
        );
        const rootCol = Math.max(
          parseTinaVol(r.totalVolColas),
          parseTinaVol(r.total_vol_colas),
          parseTinaVol(r.total_volumen_colas),
          parseTinaVol(r.volumenColas)
        );
        const totalVolFinal = sumTinas > 0 ? sumTinas : (rootOrd + rootCol);

        return {
          id: r.no_produccion || r.noProduccion || r.id,
          rawId: r.id_bitacora_molienda || r.id,
          idBitacoraMolienda: r.id_bitacora_molienda || r.id,
          id_bitacora_coccion: r.id_bitacora_coccion || r.idBitacoraCoccion || foundCoccion?.rawId || foundCoccion?.id || null,
          idBitacoraCoccion: r.id_bitacora_coccion || r.idBitacoraCoccion || foundCoccion?.rawId || foundCoccion?.id || null,
          noProduccion: r.no_produccion || r.noProduccion,
          observaciones: r.observaciones || "",
          inspector: r.inspector || "Pendiente de V.Bo.",
          status: r.estatus || r.status || "enviada",
          statusUI: r.statusUI || r.estatus || "nueva",
          observacionesInspector: r.observaciones_correccion || r.observacionesInspector || "",
          coccion: foundCoccion,
          tipoMaguey: r.tipo_maguey || r.tipoMaguey || foundCoccion?.tipoMaguey || "",
          totalVolOrdinario: totalVolFinal,
          totalVolMezcal: totalVolFinal,
          totalVolColas: rootCol,
          totalKgMaguey: parseTinaVol(r.totalKgMaguey || r.total_kg_maguey),
          items: formattedItems
        };
      });
    }

    return productionLots.filter(l => l.molienda).map(l => {
      const foundCoccion = l.coccion || (Array.isArray(coccionSectionRecords) ? coccionSectionRecords : []).find(c =>
        c.noProduccion === l.noProduccion || String(c.rawId) === String(l.id_bitacora_coccion)
      ) || null;

      const rawTinas = (Array.isArray(l.molienda.items) && l.molienda.items.length > 0 ? l.molienda.items : null) ||
        (Array.isArray(l.molienda.tinas) && l.molienda.tinas.length > 0 ? l.molienda.tinas : null) ||
        [];

      const formattedItems = rawTinas.map((it, idx) => {
        const rawKg = parseTinaVol(it.kgMaguey || it.kg_maguey);
        const rawVForm = parseTinaVol(it.volumenFormulado || it.volumen_formulado);
        const rawVOrd = Math.max(
          parseTinaVol(it.volumenOrdinario),
          parseTinaVol(it.volumen_ordinario),
          parseTinaVol(it.volumenMezcal),
          parseTinaVol(it.volumen_mezcal)
        );
        const rawVCol = Math.max(
          parseTinaVol(it.volumenColas),
          parseTinaVol(it.volumen_colas)
        );
        const rawPAlcOrd = parseTinaVol(it.pctAlcOrdinario || it.pct_alc_mezcal || it.pctAlcMezcal);
        const rawPAlcCol = parseTinaVol(it.pctAlcColas || it.pct_alc_colas);

        const tinaSum1ra = (rawVOrd + rawVCol) > 0 ? (rawVOrd + rawVCol) : parseTinaVol(it.volumen || it.volumen_1ra || it.totalVol);

        return {
          ...it,
          id: it.id || (idx + 1),
          contenedor: it.contenedor || `Tina ${idx + 1 < 10 ? '0' + (idx + 1) : idx + 1}`,
          kgMaguey: typeof it.kgMaguey === 'number' ? `${it.kgMaguey.toLocaleString()} kg` : it.kgMaguey,
          volumenFormulado: typeof it.volumenFormulado === 'number' ? `${it.volumenFormulado.toLocaleString()} L` : it.volumenFormulado,
          volumenOrdinario: typeof it.volumenOrdinario === 'number' ? `${it.volumenOrdinario.toLocaleString()} L` : (it.volumenOrdinario ? `${it.volumenOrdinario} L` : (typeof it.volumenMezcal === 'number' ? `${it.volumenMezcal.toLocaleString()} L` : (it.volumenMezcal ? `${it.volumenMezcal} L` : it.volumenMezcal))),
          volumenMezcal: typeof it.volumenMezcal === 'number' ? `${it.volumenMezcal.toLocaleString()} L` : (it.volumenOrdinario ? `${it.volumenOrdinario} L` : it.volumenMezcal),
          pctAlcOrdinario: typeof it.pctAlcOrdinario === 'number' ? `${it.pctAlcOrdinario}%` : (it.pctAlcOrdinario ? `${it.pctAlcOrdinario}%` : (typeof it.pctAlcMezcal === 'number' ? `${it.pctAlcMezcal}%` : it.pctAlcMezcal)),
          pctAlcMezcal: typeof it.pctAlcMezcal === 'number' ? `${it.pctAlcMezcal}%` : (it.pctAlcOrdinario ? `${it.pctAlcOrdinario}%` : it.pctAlcMezcal),
          volumenColas: typeof it.volumenColas === 'number' ? `${it.volumenColas.toLocaleString()} L` : it.volumenColas,
          pctAlcColas: typeof it.pctAlcColas === 'number' ? `${it.pctAlcColas}%` : it.pctAlcColas,
          rawKgMaguey: rawKg,
          rawVolumenFormulado: rawVForm,
          rawVolumenOrdinario: rawVOrd,
          rawVolumenMezcal: rawVOrd,
          rawVolumenColas: rawVCol,
          rawPctAlcOrdinario: rawPAlcOrd,
          rawPctAlcColas: rawPAlcCol,
          totalTina1raDestilacion: tinaSum1ra
        };
      });

      const sumTinas = formattedItems.reduce((acc, it) => acc + (it.totalTina1raDestilacion || (it.rawVolumenOrdinario + it.rawVolumenColas)), 0);
      const rootOrd = parseTinaVol(l.molienda.totalVolOrdinario || l.molienda.totalVolMezcal);
      const totalVolFinal = sumTinas > 0 ? sumTinas : rootOrd;

      return {
        id: l.noProduccion,
        rawId: l.id_bitacora_molienda || l.molienda?.id_bitacora_molienda || l.molienda?.id || l.id,
        idBitacoraMolienda: l.id_bitacora_molienda || l.molienda?.id_bitacora_molienda || l.molienda?.id || l.id,
        id_bitacora_coccion: l.id_bitacora_coccion || l.coccion?.id_bitacora_coccion || l.coccion?.idBitacoraCoccion || l.coccion?.rawId || l.coccion?.id || foundCoccion?.rawId || foundCoccion?.id || null,
        idBitacoraCoccion: l.id_bitacora_coccion || l.coccion?.id_bitacora_coccion || l.coccion?.idBitacoraCoccion || l.coccion?.rawId || l.coccion?.id || foundCoccion?.rawId || foundCoccion?.id || null,
        noProduccion: l.noProduccion,
        observaciones: l.molienda.observaciones,
        inspector: l.inspector,
        status: l.statusUI === "aprobado_ui" || l.statusUI === "aprobado" ? "aprobado" : l.statusUI === "rechazado" ? "rechazado" : "borrador",
        statusUI: l.statusUI || "borrador",
        observacionesInspector: l.observacionesInspector || "",
        coccion: foundCoccion,
        tipoMaguey: l.tipoMaguey || l.coccion?.tipoMaguey || l.molienda?.tipoMaguey || foundCoccion?.tipoMaguey || "",
        totalVolOrdinario: totalVolFinal,
        totalVolMezcal: totalVolFinal,
        totalVolColas: parseTinaVol(l.molienda.totalVolColas),
        totalKgMaguey: parseTinaVol(l.molienda.totalKgMaguey),
        items: formattedItems
      };
    });
  }, [productionLots, reduxMoliendaRecords, coccionSectionRecords]);

  const destilacionSectionRecords = useMemo(() => {
    if (Array.isArray(reduxDestilacionRecords) && reduxDestilacionRecords.length > 0) {
      return reduxDestilacionRecords.map(r => ({
        id: r.no_produccion || r.noProduccion || r.id,
        rawId: r.id_bitacora_destilacion || r.id,
        noProduccion: r.no_produccion || r.noProduccion,
        id_bitacora_molienda: r.id_bitacora_molienda,
        fechaSegunda: r.fechaRegistro || r.fecha_registro,
        destiladorNum: r.tipoAlambique || r.items?.[0]?.tipoAlambique || "",
        volADestilar: typeof r.totalVolCargado === 'number' ? `${r.totalVolCargado.toLocaleString()} L` : (r.totalVolCargado || "0 L"),
        puntas: typeof r.totalPuntas === 'number' ? `${r.totalPuntas.toLocaleString()} L` : (r.totalPuntas || "0 L"),
        mezcal: `${r.totalMezcalObtenido || r.totalVolMezcal || 0} L (${r.avgAlcMezcal || 0}%)`,
        colas: typeof r.totalColas === 'number' ? `${r.totalColas.toLocaleString()} L` : (r.totalColas || "0 L"),
        observaciones: r.observaciones || "",
        inspector: r.inspector || "Pendiente de V.Bo.",
        status: r.estatus || r.status || "enviada",
        statusUI: r.statusUI || r.estatus || "nueva",
        observacionesCorreccion: r.observaciones_correccion || r.observacionesInspector || "",
        observacionesInspector: r.observaciones_correccion || r.observacionesInspector || "",
        items: Array.isArray(r.items) ? r.items.map(it => ({
          ...it,
          volADestilar: typeof it.volADestilar === 'number' ? `${it.volADestilar.toLocaleString()} L` : it.volADestilar,
          puntasVol: typeof it.puntasVol === 'number' ? `${it.puntasVol.toLocaleString()} L` : it.puntasVol,
          puntasAlc: typeof it.puntasAlc === 'number' ? `${it.puntasAlc}%` : it.puntasAlc,
          mezcalVol: typeof it.mezcalVol === 'number' ? `${it.mezcalVol.toLocaleString()} L` : it.mezcalVol,
          mezcalAlc: typeof it.mezcalAlc === 'number' ? `${it.mezcalAlc}%` : it.mezcalAlc,
          colasVol: typeof it.colasVol === 'number' ? `${it.colasVol.toLocaleString()} L` : it.colasVol,
          colasAlc: typeof it.colasAlc === 'number' ? `${it.colasAlc}%` : it.colasAlc
        })) : []
      }));
    }

    return productionLots.filter(l => l.destilacion).map(l => {
      const normStatus = String(l.destilacion?.status || l.statusUI || '').toLowerCase().trim();
      let mappedStatus = "borrador";
      if (normStatus.includes("aceptad") || normStatus.includes("aprobad")) mappedStatus = "aceptada";
      else if (normStatus.includes("revision")) mappedStatus = "en_revision";
      else if (normStatus.includes("enviad") || normStatus.includes("pendiente")) mappedStatus = "enviada";
      else if (normStatus.includes("rechazad")) mappedStatus = "rechazada";
      else if (normStatus.includes("cancelad")) mappedStatus = "cancelada";

      return {
        id: l.destilacion.id || l.noProduccion,
        rawId: l.destilacion.id || l.noProduccion,
        noProduccion: l.noProduccion,
        id_bitacora_molienda: l.destilacion.id_bitacora_molienda || (l.molienda ? (l.molienda.id || l.molienda.rawId) : null),
        fechaSegunda: l.destilacion.fechaRegistro,
        destiladorNum: l.destilacion.tipoAlambique,
        volADestilar: `${l.destilacion.totalVolCargado} L`,
        puntas: `${l.destilacion.totalPuntas} L`,
        mezcal: `${l.destilacion.totalMezcalObtenido} L (${l.destilacion.avgAlcMezcal}%)`,
        colas: `${l.destilacion.totalColas} L`,
        observaciones: l.destilacion.observaciones,
        inspector: l.inspector,
        status: mappedStatus,
        observacionesCorreccion: l.observacionesInspector || l.observaciones_correccion || "",
        items: l.destilacion.items || []
      };
    });
  }, [productionLots, reduxDestilacionRecords]);

  const granelSectionRecords = useMemo(() => {
    const list = [];
    const seenIds = new Set();
    const existingDestilacionIds = new Set();
    const existingDestilacionDetalleIds = new Set();
    const existingMaduracionIds = new Set();
    const existingLotes = new Set();

    // 1. Mapeo de registros en customGranelRecords por ID y por No. Lote (para cambios optimistas de dilución, baja, muestreo, etc.)
    const customMap = new Map();
    const customLoteMap = new Map();
    (customGranelRecords || []).forEach(rec => {
      const recId = rec.id || rec.dbId || rec.id_bitacora_granel;
      if (recId) customMap.set(String(recId), rec);
      const loteKey = String(rec.noLote || rec.no_lote || "").trim();
      if (loteKey) customLoteMap.set(loteKey, rec);
    });

    // 1.1. Registros de Granel cargados de la base de datos (Redux / PostgreSQL)
    (reduxGranelRecords || []).forEach(g => {
      const gId = g.id || g.id_bitacora_granel || g.dbId;
      const gLote = String(g.noLote || g.no_lote || "").trim();

      // DEDUPLICACIÓN ESTRICTA: No procesar dos veces el mismo ID o el mismo lote
      if (gId && !seenIds.has(String(gId)) && (!gLote || !existingLotes.has(gLote))) {
        seenIds.add(String(gId));
        if (gLote) existingLotes.add(gLote);

        // Combinar con versión optimista si existe (por ID o por noLote)
        const customVersion = customMap.get(String(gId)) || (gLote ? customLoteMap.get(gLote) : null);
        const merged = customVersion ? { ...g, ...customVersion, id: gId, dbId: gId, id_bitacora_granel: gId } : { ...g };

        const litrosNum = Number(merged.litros ?? merged.volFinal ?? merged.invFinalVol ?? 0);
        const alcNum = Number(merged.porcentaje_alc_vol ?? merged.alcFinal ?? merged.invFinalAlc ?? 0);

        const norm = {
          ...merged,
          id: gId,
          dbId: gId,
          id_bitacora_granel: gId,
          noLote: merged.noLote || merged.no_lote || "",
          no_lote: merged.no_lote || merged.noLote || "",
          idContenedor: merged.idContenedor || merged.no_tanque || "",
          no_tanque: merged.no_tanque || merged.idContenedor || "",
          litros: litrosNum,
          litrosTotal: litrosNum,
          volFinal: litrosNum,
          volumen: litrosNum,
          saldoFinal: litrosNum,
          invFinalVol: String(litrosNum),
          invInicialVol: String(merged.invInicialVol ?? litrosNum),
          porcentaje_alc_vol: alcNum,
          alcFinal: alcNum,
          invFinalAlc: String(alcNum),
          invInicialAlc: String(merged.invInicialAlc ?? alcNum),
          status: merged.status || (merged.estatus === "activo" ? "aprobado" : merged.estatus) || "borrador",
          statusUI: merged.statusUI || (merged.estatus === "activo" ? "aprobado" : merged.estatus) || "borrador",
          fechaMovimiento: merged.fechaMovimiento || merged.fecha || ""
        };

        list.push(norm);

        // Registrar referencias vinculadas para no generar duplicados sintéticos
        if (norm.id_bitacora_destilacion) existingDestilacionIds.add(Number(norm.id_bitacora_destilacion));
        if (norm.rawIdDestilacion) existingDestilacionIds.add(Number(norm.rawIdDestilacion));
        if (norm.id_destilacion_detalle) existingDestilacionDetalleIds.add(Number(norm.id_destilacion_detalle));
        if (norm.rawIdDestilacionDetalle) existingDestilacionDetalleIds.add(Number(norm.rawIdDestilacionDetalle));
        if (norm.id_bitacora_maduracion) existingMaduracionIds.add(Number(norm.id_bitacora_maduracion));
      }
    });

    // 1.2. Agregar registros locales de customGranelRecords que aún no existan en la BD (nuevos borradores)
    (customGranelRecords || []).forEach(rec => {
      const recId = rec.id || rec.dbId || rec.id_bitacora_granel;
      const recLote = String(rec.noLote || rec.no_lote || "").trim();

      // DEDUPLICACIÓN CRÍTICA: Omitir si el ID o el No. de Lote ya existe en la lista
      if (recId && !seenIds.has(String(recId)) && (!recLote || !existingLotes.has(recLote))) {
        seenIds.add(String(recId));
        if (recLote) existingLotes.add(recLote);
        list.unshift(rec);
        if (rec.id_bitacora_destilacion) existingDestilacionIds.add(Number(rec.id_bitacora_destilacion));
        if (rec.id_destilacion_detalle) existingDestilacionDetalleIds.add(Number(rec.id_destilacion_detalle));
        if (rec.id_bitacora_maduracion) existingMaduracionIds.add(Number(rec.id_bitacora_maduracion));
      }
    });

    // 2. Lotes con etapa granel en productionLots (solo si no existen en BD ni en la lista)
    (productionLots || []).forEach(l => {
      const pLote = String(l.granel?.noLote || l.noProduccion || "").trim();
      const pId = String(l.granel?.id || l.noProduccion || "");
      if (l.granel && !seenIds.has(pId) && !existingLotes.has(pLote)) {
        list.push({
          id: l.granel.id || l.noProduccion,
          noLote: l.granel.noLote || l.noProduccion,
          idContenedor: l.granel.idContenedor || l.granel.no_tanque || "",
          categoria: l.granel.categoria || l.categoria || "Mezcal Artesanal",
          clase: l.granel.clase || "Blanco Joven",
          fechaMovimiento: l.granel.fechaMovimiento || l.fechaActualizacion || l.fechaInicio || "",
          noAnalisisFisicoquimico: l.granel.noAnalisisFisicoquimico || l.granel.noAnalisis || "",
          noAnalisis: l.granel.noAnalisis || l.granel.noAnalisisFisicoquimico || "",
          tipoMaguey: l.granel.tipoMaguey || l.granel.especie || "",
          ingredientes: l.granel.ingredientes || "",
          invInicialVol: String(l.granel.volInicial || l.granel.invInicialVol || "0").replace(/[^\d.]/g, ''),
          invInicialAlc: String(l.granel.alcInicial || l.granel.invInicialAlc || "0").replace(/[^\d.]/g, ''),
          entradaProcedencia: l.granel.entradaProcedencia || `2da Destilación (Lote ${l.noProduccion})`,
          entradaVolumen: String(l.granel.entradaVolumen || l.granel.volInicial || "0").replace(/[^\d.]/g, ''),
          entradaAlc: String(l.granel.entradaAlc || l.granel.alcInicial || "0").replace(/[^\d.]/g, ''),
          salidaDestino: l.granel.salidaDestino || "",
          salidaVolumen: String(l.granel.salidaVolumen || "0").replace(/[^\d.]/g, ''),
          salidaAlc: String(l.granel.salidaAlc || "0").replace(/[^\d.]/g, ''),
          invFinalVol: String(l.granel.volFinal || l.granel.invFinalVol || l.granel.volInicial || "0").replace(/[^\d.]/g, ''),
          invFinalAlc: String(l.granel.alcFinal || l.granel.invFinalAlc || l.granel.alcInicial || "0").replace(/[^\d.]/g, ''),
          observaciones: l.granel.observaciones || "",
          inspector: l.inspector || "Ing. Carlos Mendoza (UI Autorizado)",
          status: l.statusUI === "aprobado_ui" || l.statusUI === "aprobado" ? "aprobado" : (l.status || "borrador"),
          statusUI: l.statusUI || "aprobado"
        });
        seenIds.add(pId);
        if (pLote) existingLotes.add(pLote);
      }
    });

    // 3. Por cada destilación aceptada/aprobada, crear automáticamente su registro en Granel si aún NO existe en BD
    const allDestilaciones = destilacionSectionRecords || [];
    allDestilaciones.forEach(dest => {
      const rawSt = String(dest.status || dest.statusUI || '').toLowerCase().trim();
      const isAprobada = rawSt.includes("aceptad") || rawSt.includes("aprobad");
      const noProd = dest.noProduccion || dest.id;
      const rawDestId = Number(dest.rawId || dest.id_bitacora_destilacion || dest.id);

      // Si la destilación completa ya tiene registro en Granel, omitir
      if (!isAprobada || !noProd || (rawDestId && existingDestilacionIds.has(rawDestId))) {
        return;
      }

      // Buscar datos de Cocción y Molienda vinculados para determinar la categoría NOM-070
      const coccionRec = (productionLots || []).find(p => p.noProduccion === noProd)?.coccion ||
        (Array.isArray(reduxCoccionRecords) ? reduxCoccionRecords.find(c => (c.no_produccion || c.noProduccion) === noProd) : null) ||
        (Array.isArray(coccionSectionRecords) ? coccionSectionRecords.find(c => (c.no_produccion || c.noProduccion) === noProd) : null);
      const tipoHorno = coccionRec?.tipoHorno || coccionRec?.tipo_horno || "";

      const moliendaRec = (productionLots || []).find(p => p.noProduccion === noProd)?.molienda ||
        (Array.isArray(reduxMoliendaRecords) ? reduxMoliendaRecords.find(m => (m.no_produccion || m.noProduccion) === noProd || m.id === dest.id_bitacora_molienda) : null) ||
        (Array.isArray(moliendaSectionRecords) ? moliendaSectionRecords.find(m => (m.no_produccion || m.noProduccion) === noProd) : null);
      const equipoMolienda = moliendaRec?.items?.[0]?.equipoMolienda || moliendaRec?.equipoMolienda || "";
      const equipoFermentacion = moliendaRec?.items?.[0]?.equipoFermentacion || moliendaRec?.equipoFermentacion || "";

      // Tomar todos los alambiques/procesos agregados a la destilación
      const destItems = Array.isArray(dest.items) && dest.items.length > 0
        ? dest.items
        : [{
          id: dest.rawId || dest.id,
          noProceso: 1,
          fechaSegunda: dest.fechaSegunda,
          nuevoLote: dest.noProduccion,
          tipoAlambique: dest.destiladorNum,
          esDestiladoCon: dest.esDestiladoCon,
          destiladoConIngrediente: dest.destiladoConIngrediente,
          mezcalVol: parseFloat(String(dest.mezcal || dest.totalMezcalObtenido || 0).replace(/[^\d.]/g, '')) || 0,
          mezcalAlc: parseFloat(String(dest.avgAlcMezcal || dest.pctAlcMezcal || 0).replace(/[^\d.]/g, '')) || 0
        }];

      destItems.forEach((it, itIdx) => {
        // El nuevo lote que está en destilación pasa como no_lote (o no_produccion si está vacío)
        const targetLote = String(it.nuevoLote || it.nuevo_lote || it.subLote || "").trim() || noProd;
        const itDetalleId = Number(it.id || it.id_destilacion_detalle);
        const itemKey = `GRANEL-DEST-${dest.rawId || noProd}-${it.id || it.id_destilacion_detalle || it.noProceso || itIdx}`;

        // Si ya existe el detalle de destilación o el lote en Granel, no duplicar
        if (seenIds.has(itemKey) || (itDetalleId && existingDestilacionDetalleIds.has(itDetalleId)) || existingLotes.has(targetLote)) {
          return;
        }

        const volMezcal = parseFloat(String(it.mezcalVol || it.mezcalVolumen || it.mezcal || 0).replace(/[^\d.]/g, '')) || 0;
        const alcMezcal = parseFloat(String(it.mezcalAlc || it.mezcalPctAlc || dest.avgAlcMezcal || 0).replace(/[^\d.]/g, '')) || 0;
        const tipoAlambique = it.tipoAlambique || it.destiladorNum || dest.destiladorNum || "";

        // Categoría según matriz NOM-070 ('Mezcal', 'Mezcal Artesanal' o 'Mezcal Ancestral')
        const categoria = calcularCategoriaMezcal({
          tipoHorno,
          equipoMolienda,
          equipoFermentacion,
          tipoAlambique
        });

        // Clase: si en destilación seleccionó destilado con es 'Destilado con', sino 'Blanco Joven'
        const isDestCon = Boolean(it.esDestiladoCon || (it.destiladoConIngrediente && String(it.destiladoConIngrediente).trim() !== ""));
        const clase = isDestCon ? "Destilado con" : "Blanco Joven";
        const ingredientes = isDestCon ? (it.destiladoConIngrediente || it.ingrediente || "") : "";

        // Obtener especie(s) del lote con orden Nombre Común (Nombre Científico)
        const rawMagueyList = (Array.isArray(coccionRec?.magueyes) && coccionRec.magueyes.length > 0)
          ? coccionRec.magueyes
          : (Array.isArray(coccionRec?.coccion?.magueyes) && coccionRec.coccion.magueyes.length > 0)
            ? coccionRec.coccion.magueyes
            : (coccionRec?.tipoMaguey || dest.tipoMaguey)
              ? [{ tipoMaguey: coccionRec?.tipoMaguey || dest.tipoMaguey }]
              : [];

        const formattedMagueyes = rawMagueyList.map(m => {
          const rawStr = m.tipoMaguey || m.nombreComun || m.nombre_comun || "";
          return formatMagueyNombreComunPrimero(rawStr, catalogoMaguey);
        }).filter(Boolean);

        const especieStr = formattedMagueyes.length > 0 ? formattedMagueyes.join(" + ") : "";

        list.push({
          id: itemKey,
          rawIdDestilacion: dest.rawId || dest.id,
          rawIdDestilacionDetalle: it.id || it.id_destilacion_detalle,
          noLote: targetLote,
          no_lote: targetLote,
          idContenedor: "", // Tanque asignable en Granel
          no_tanque: "",
          tipoMaguey: especieStr,
          especie: especieStr,
          categoria: categoria,
          clase: clase,
          ingredientes: ingredientes,
          fechaMovimiento: it.fechaSegunda || it.fechaSegundaDestilacion || dest.fechaSegunda || new Date().toISOString().split('T')[0],
          noAnalisisFisicoquimico: "",
          noAnalisis: "",
          litros: volMezcal,
          litrosTotal: volMezcal,
          volFinal: volMezcal,
          saldoFinal: volMezcal,
          porcentaje_alc_vol: alcMezcal,
          alcFinal: alcMezcal,
          invInicialVol: String(volMezcal),
          invInicialAlc: String(alcMezcal),
          entradaProcedencia: `2da Destilación (Lote ${noProd}${it.noProceso ? ` / Alambique #${it.noProceso}` : ''})`,
          entradaVolumen: String(volMezcal),
          entradaAlc: String(alcMezcal),
          salidaDestino: "",
          salidaVolumen: "0",
          salidaAlc: "0",
          invFinalVol: String(volMezcal),
          invFinalAlc: String(alcMezcal),
          observaciones: `Registro automático por aceptación de 2da Destilación (Alambique #${it.noProceso || (itIdx + 1)} / Lote ${noProd}).`,
          inspector: dest.inspector || "Inspector UI",
          status: "aprobado",
          statusUI: "aprobado",
          tipo_granel: "Granel"
        });
        seenIds.add(itemKey);
        if (itDetalleId) existingDestilacionDetalleIds.add(itDetalleId);
        if (targetLote) existingLotes.add(targetLote);
      });
    });

    // 4. Por cada lote de Maduración aceptado/aprobado con salida registrada, transferir automáticamente a Granel solo si NO existe ya en BD
    const allMaduraciones = effectiveMaduracionRecords || [];
    allMaduraciones.forEach(mad => {
      const rawSt = String(mad.status || mad.estatus || mad.statusUI || '').toLowerCase().trim();
      const isAprobada = rawSt.includes("aceptad") || rawSt.includes("aprobad") || rawSt === "aprobada";
      const primerRec = (Array.isArray(mad.recipientes) && mad.recipientes[0]) || {};
      const volSalida = parseFloat(mad.volumen_salida_total || mad.salidaVolumen || primerRec.salida_volumen || primerRec.salidaVolumen || 0);

      if (isAprobada && volSalida > 0) {
        const madId = Number(mad.id_bitacora_maduracion || mad.id);
        const targetLote = String(
          mad.nuevo_lote || mad.nuevoLote || primerRec.nuevo_lote || primerRec.nuevoLote ||
          `MAD-${mad.noLote || mad.lote_maduracion || madId}`
        ).trim();
        const itemKey = `GRANEL-MAD-${madId}-${targetLote}`;

        if (seenIds.has(itemKey) || (madId && existingMaduracionIds.has(madId)) || existingLotes.has(targetLote)) {
          return;
        }

        const alcSalida = parseFloat(mad.salida_alc || mad.salidaAlc || primerRec.salida_alc || primerRec.salidaAlc || 0);
        const claseCalc = mad.clase_obtenida || mad.claseObtenida || primerRec.clase_obtenida || primerRec.claseObtenida || "Añejo";
        const cat = mad.categoria || "Mezcal Artesanal";
        const especieMaguey = mad.tipo_maguey || mad.tipoMaguey || mad.especie || "";

        const recCount = primerRec.invInicialRecipientes || primerRec.noRecipientes || 1;
        const recTipo = primerRec.tipoRecipiente || primerRec.tipo_recipiente || "Barricas";
        const barricasStr = mad.no_barricas || `${recCount} ${recTipo}`.trim();

        list.push({
          id: itemKey,
          id_bitacora_maduracion: mad.id_bitacora_maduracion || (typeof mad.id === "number" ? mad.id : null),
          noLote: targetLote,
          no_lote: targetLote,
          idContenedor: primerRec.detalleRecipiente || primerRec.detalle_recipiente || "BODEGA-MAD",
          no_tanque: primerRec.detalleRecipiente || primerRec.detalle_recipiente || "BODEGA-MAD",
          no_barricas: barricasStr,
          noBarricas: barricasStr,
          tipoMaguey: especieMaguey,
          especie: especieMaguey,
          categoria: cat,
          clase: claseCalc,
          ingredientes: "",
          ingrediente: "",
          noAnalisisFisicoquimico: "",
          noAnalisis: "",
          clave_fq: "",
          fechaMovimiento: primerRec.salidaFecha || primerRec.salida_fecha || mad.fecha_salida_maduracion || mad.fechaMovimiento || new Date().toISOString().split('T')[0],
          invInicialVol: String(volSalida),
          invInicialAlc: String(alcSalida),
          entradaProcedencia: `Maduración (Lote origen: ${mad.no_lote_origen || mad.loteOrigen || mad.noLote || mad.lote_maduracion})`,
          entradaVolumen: String(volSalida),
          entradaAlc: String(alcSalida),
          salidaDestino: "",
          salidaVolumen: "0",
          salidaAlc: "0",
          invFinalVol: String(volSalida),
          invFinalAlc: String(alcSalida),
          litros: volSalida,
          litrosTotal: volSalida,
          volFinal: volSalida,
          saldoFinal: volSalida,
          porcentaje_alc_vol: alcSalida,
          alcFinal: alcSalida,
          observaciones: `Ingreso automático a Granel por salida dictaminada de Maduración (Lote ${mad.noLote || mad.lote_maduracion} -> Nuevo Lote: ${targetLote}).`,
          inspector: mad.inspector || mad.vbo_inspector || "Inspector UI",
          status: "aprobado",
          statusUI: "aprobado",
          tipo_granel: "Granel",
          id_unidad_produccion: mad.id_unidad_produccion || null,
          instalacion: mad.instalacion || ""
        });

        seenIds.add(itemKey);
        if (madId) existingMaduracionIds.add(madId);
        if (targetLote) existingLotes.add(targetLote);
      }
    });

    return list;
  }, [customGranelRecords, reduxGranelRecords, productionLots, destilacionSectionRecords, coccionSectionRecords, moliendaSectionRecords, reduxCoccionRecords, reduxMoliendaRecords, effectiveMaduracionRecords]);

  // ===================================
  // ACCIONES Y APERTURA DE MODALES
  // ===================================

  const handleOpenNuevaCoccion = (optionalCoccion = null) => {
    const today = new Date().toISOString().split('T')[0];
    const defaultInst = availableInstalaciones[0];
    const defaultInstId = defaultInst ? String(defaultInst.idanexocliente || defaultInst.id || "") : "";
    const defaultInstAlias = defaultInst ? (defaultInst.informaciongeneralinstalacioncliente?.alias || defaultInst.alias || "") : "";

    if (optionalCoccion) {
      // Edición o carga de cocción existente
      const rec = optionalCoccion;
      let parsedMagueyes = [{ id: Date.now(), tipoMaguey: rec.tipoMaguey || (Array.isArray(MAGUEY_SPECIES) ? MAGUEY_SPECIES[0] : "Agave angustifolia Haw (Espadín)"), numPinas: String(rec.numPinas || rec.pinas || "0"), kgMaguey: String(rec.kgMaguey || rec.kgMagueyCrudo || "0") }];
      if (Array.isArray(rec.magueyes) && rec.magueyes.length > 0) {
        parsedMagueyes = rec.magueyes.map((m, idx) => ({
          id: m.id || (Date.now() + idx),
          tipoMaguey: m.tipoMaguey || (Array.isArray(MAGUEY_SPECIES) ? MAGUEY_SPECIES[0] : "Agave angustifolia Haw (Espadín)"),
          numPinas: String(m.numPinas || m.pinas || 0),
          kgMaguey: String(m.kgMaguey || 0)
        }));
      }

      setFormSectionData({
        id: rec.id || rec.rawId,
        rawId: rec.rawId || rec.id,
        idUnidadProduccion: rec.idUnidadProduccion || rec.id_unidad_produccion || "",
        unidadProduccion: rec.unidadProduccion || "",
        noProduccion: rec.noProduccion || rec.no_produccion || "",
        magueyes: parsedMagueyes,
        fechaIngreso: rec.fechaIngreso || today,
        guiaPredio: rec.guiaPredio || rec.guia_predio || "",
        pctArt: rec.pctArt ? String(rec.pctArt).replace(/[^\d.]/g, '') : "",
        noInforme: rec.noInforme || rec.no_informe || "",
        tipoHorno: rec.tipoHorno || rec.tipo_horno || "",
        fechaInicioCoccion: rec.fechaInicioCoccion || rec.fechaInicio || "",
        fechaFinCoccion: rec.fechaFinCoccion || rec.fechaFin || "",
        kgMagueyCocido: rec.kgMagueyCocido ? String(rec.kgMagueyCocido).replace(/[^\d.]/g, '') : "",
        observaciones: rec.observaciones || "",
        observacionesCorreccion: rec.observacionesCorreccion || rec.observaciones_correccion || "",
        status: rec.status || rec.estatus || "borrador"
      });
    } else {
      setFormSectionData({
        id: null,
        rawId: null,
        idUnidadProduccion: "",
        unidadProduccion: "",
        noProduccion: "",
        magueyes: [
          {
            id: Date.now(),
            tipoMaguey: "",
            numPinas: "",
            kgMaguey: "",
            guiaPredio: ""
          }
        ],
        fechaIngreso: "",
        guiaPredio: "",
        pctArt: "",
        noInforme: "",
        tipoHorno: "",
        fechaInicioCoccion: "",
        fechaFinCoccion: "",
        kgMagueyCocido: "",
        observaciones: "",
        status: "borrador"
      });
    }

    setActiveTab(1);
    setIsSectionFormOpen(true);
  };

  const handleSaveCoccion = (statusOrEvent, optionalData = null) => {
    if (statusOrEvent && statusOrEvent.preventDefault) statusOrEvent.preventDefault();

    // Determinar fuente de datos (CoccionSection modal vs Tab 0 modal)
    const src = optionalData || formSectionData || {};

    const noProd = (src.noProduccion || "").trim();
    if (!noProd) {
      Swal.fire("Atención", "El número de producción es obligatorio.", "warning");
      return;
    }

    const rawStatus = typeof statusOrEvent === 'string' ? statusOrEvent : (src.estatus || src.status || "enviada");
    const isBorrador = rawStatus === "borrador";
    const finalEstatus = isBorrador ? "borrador" : "enviada";
    const statusUI = finalEstatus === "enviada" ? "pendiente_ui" : (rawStatus === "aprobado" || rawStatus === "aceptada" ? "aprobado_ui" : "borrador_ui");

    const magueyesList = (Array.isArray(src.magueyes) && src.magueyes.length > 0) ? src.magueyes : [];
    let numPinas = Number(src.numPinas || src.pinas || 0) || 0;
    let kgCrudo = Number(String(src.kgMaguey != null ? src.kgMaguey : (src.kgMagueyCrudo || 0)).replace(/[^\d.]/g, '')) || 0;
    let tipoMagueySummary = src.tipoMaguey || (Array.isArray(MAGUEY_SPECIES) ? MAGUEY_SPECIES[0] : "Agave angustifolia Haw (Espadín)");

    if (magueyesList.length > 0) {
      numPinas = magueyesList.reduce((acc, m) => acc + (Number(String(m.numPinas || m.pinas || 0).replace(/[^\d.]/g, '')) || 0), 0);
      kgCrudo = magueyesList.reduce((acc, m) => acc + (Number(String(m.kgMaguey || 0).replace(/[^\d.]/g, '')) || 0), 0);
      tipoMagueySummary = magueyesList.map(m => m.tipoMaguey).filter(Boolean).join(" + ") || tipoMagueySummary;
    }

    const kgCocido = Number(String(src.kgMagueyCocido || 0).replace(/[^\d.]/g, '')) || 0;

    // Validación de % ART (rango 0 a 100)
    let pctArt = null;
    const rawPctArt = src.pctArt !== undefined && src.pctArt !== null ? String(src.pctArt).trim() : "";
    if (rawPctArt !== "") {
      const numArt = Number(rawPctArt.replace(/[^\d.]/g, ''));
      if (!isNaN(numArt)) {
        if (numArt < 0 || numArt > 100) {
          Swal.fire({
            title: "Valor de % ART Inválido",
            text: "El porcentaje de Azúcares Reductores Totales (% ART) debe estar en el rango de 0% a 100%.",
            icon: "warning",
            confirmButtonColor: "#4A5D23"
          });
          return;
        }
        pctArt = numArt;
      }
    }

    // Validación de campos obligatorios cuando se envía a revisión oficial
    if (!isBorrador) {
      const missingList = [];
      if (!noProd) missingList.push({ campo: "No. de Producción (Lote)", detalle: "Ingrese el folio único de producción." });
      if (!src.idUnidadProduccion) missingList.push({ campo: "Instalación (Unidad de Producción)", detalle: "Seleccione la instalación autorizada (Anexo 1)." });
      if (!src.fechaIngreso) missingList.push({ campo: "Fecha de Ingreso de Maguey", detalle: "Indique la fecha de recepción del maguey." });
      if (numPinas <= 0) missingList.push({ campo: "Número de Piñas", detalle: "Debe ser mayor a 0 piñas." });
      if (kgCrudo <= 0) missingList.push({ campo: "Kilogramos de Maguey Crudo", detalle: "Debe ser mayor a 0 kg." });

      if (magueyesList.length === 0) {
        missingList.push({ campo: "Especies de Maguey", detalle: "Registre al menos una especie de agave." });
      } else {
        magueyesList.forEach((m, idx) => {
          if (!m.tipoMaguey) missingList.push({ campo: `Especie #${idx + 1}: Variedad`, detalle: "Seleccione la variedad de agave." });
          // Guía / predio es opcional
        });
      }

      if (!src.tipoHorno) missingList.push({ campo: "Tipo de Horno Empleado", detalle: "Seleccione el tipo de horno utilizado." });
      if (!src.fechaInicioCoccion) missingList.push({ campo: "Fecha Inicial de Cocción", detalle: "Indique la fecha de inicio del horneado." });
      if (!src.fechaFinCoccion) missingList.push({ campo: "Fecha Final de Cocción", detalle: "Indique la fecha de conclusión del horneado." });
      if (kgCocido <= 0) missingList.push({ campo: "Kg de Maguey Cocido Obtenido", detalle: "Registre el pesaje total de maguey cocido (> 0 kg)." });

      if (missingList.length > 0) {
        Swal.fire({
          title: '<div style="display:flex;align-items:center;justify-content:center;gap:10px;color:#991B1B;font-size:20px;font-weight:800;"><span style="font-size:24px;">⚠️</span> Campos Obligatorios Incompletos</div>',
          html: `
            <div style="text-align:left;font-family:inherit;">
              <p style="margin:0 0 12px 0;color:#4B5563;font-size:13px;line-height:1.5;">
                Para enviar la bitácora de cocción a revisión oficial, debe completar los siguientes <strong>${missingList.length} dato(s) obligatorio(s)</strong>:
              </p>
              <div style="max-height:280px;overflow-y:auto;background:#FFF5F5;border:1px solid #FECACA;border-radius:12px;padding:12px 14px;">
                <ul style="list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:10px;">
                  ${missingList.map((item, idx) => `
                    <li style="display:flex;align-items:flex-start;gap:10px;padding-bottom:8px;border-bottom:${idx === missingList.length - 1 ? 'none' : '1px solid #FEE2E2'};">
                      <span style="font-size:16px;line-height:1;margin-top:2px;">❌</span>
                      <div style="flex:1;">
                        <strong style="color:#991B1B;font-size:13px;display:block;">${item.campo}</strong>
                        <span style="color:#6B7280;font-size:11.5px;line-height:1.4;display:block;margin-top:2px;">${item.detalle}</span>
                      </div>
                    </li>
                  `).join('')}
                </ul>
              </div>
            </div>
          `,
          confirmButtonText: 'Entendido, Completar Formulario',
          confirmButtonColor: '#4A5D23',
          background: '#FFFFFF',
          width: '580px'
        });
        return;
      }
    }

    // Despachar registro al Backend (BackendInspeccion)
    if (idLogin) {
      const sanitizedMagueyes = (Array.isArray(magueyesList) && magueyesList.length > 0)
        ? magueyesList.map(m => {
          const rawGuia = (m.guiaPredio !== undefined && m.guiaPredio !== null)
            ? String(m.guiaPredio).trim()
            : ((m.guia_predio !== undefined && m.guia_predio !== null) ? String(m.guia_predio).trim() : "");
          const finalGuia = rawGuia !== "" ? rawGuia : " ";
          return {
            ...m,
            guiaPredio: finalGuia,
            guia_predio: finalGuia
          };
        })
        : [{
          tipoMaguey: tipoMagueySummary,
          numPinas: numPinas,
          kgMaguey: kgCrudo,
          guiaPredio: (src.guiaPredio && String(src.guiaPredio).trim()) || (src.guia_predio && String(src.guia_predio).trim()) || " ",
          guia_predio: (src.guiaPredio && String(src.guiaPredio).trim()) || (src.guia_predio && String(src.guia_predio).trim()) || " "
        }];

      const guiasValidas = sanitizedMagueyes.map(m => m.guiaPredio.trim()).filter(Boolean);
      const summaryGuia = guiasValidas.length > 0
        ? guiasValidas.join(" / ")
        : ((src.guiaPredio && String(src.guiaPredio).trim()) || (src.guia_predio && String(src.guia_predio).trim()) || " ");

      const payload = {
        id_login: idLogin,
        id_unidad_produccion: src.idUnidadProduccion,
        no_produccion: noProd,
        num_pinas: numPinas,
        kg_maguey: kgCrudo,
        fecha_ingreso: src.fechaIngreso,
        guia_predio: summaryGuia,
        tipo_maguey: tipoMagueySummary,
        magueyes: sanitizedMagueyes,
        pct_art: pctArt,
        no_informe: src.noInforme || "",
        tipo_horno: src.tipoHorno || null,
        fecha_inicio_coccion: src.fechaInicioCoccion || null,
        fecha_fin_coccion: src.fechaFinCoccion || null,
        kg_maguey_cocido: (src.kgMagueyCocido !== "" && src.kgMagueyCocido != null) ? Number(src.kgMagueyCocido) : null,
        observaciones: src.observaciones || null,
        estatus: finalEstatus
      };

      const reloadLists = () => {
        if (activeTab === 1) {
          dispatch(obtenerCoccionesPorLogin({
            id_login: idLogin,
            page: coccionPage,
            limit: coccionLimit,
            search: coccionSearch,
            estatus: coccionStatusFilter
          }));
        } else {
          dispatch(obtenerTrazabilidadAsociado({
            id_login: idLogin,
            page: tracePage,
            limit: traceLimit,
            search: searchTerm,
            estatus: selectedStatusFilter
          }));
        }
      };

      if (src.rawId) {
        dispatch(actualizarCoccion({ id: src.rawId, coccionData: payload }))
          .then((res) => {
            if (res.error) {
              const errMsg = res.payload || res.error.message || "Error al actualizar la cocción.";
              Swal.fire({
                title: '<div style="display:flex;align-items:center;justify-content:center;gap:10px;color:#991B1B;font-size:20px;font-weight:800;"><span style="font-size:24px;">⚠️</span> Inconsistencia o Dato Faltante</div>',
                html: `
                  <div style="text-align:left;font-family:inherit;">
                    <p style="margin:0 0 12px 0;color:#4B5563;font-size:13px;line-height:1.5;">
                      El servidor indicó la siguiente observación al procesar la <strong>Bitácora de Cocción</strong>:
                    </p>
                    <div style="background:#FFF5F5;border:1px solid #FECACA;border-radius:12px;padding:12px 14px;">
                      <div style="display:flex;align-items:flex-start;gap:10px;">
                        <span style="font-size:18px;line-height:1;margin-top:2px;">❌</span>
                        <div style="flex:1;">
                          <strong style="color:#991B1B;font-size:13px;display:block;">Validación Requerida</strong>
                          <span style="color:#6B7280;font-size:12px;line-height:1.4;display:block;margin-top:3px;">${errMsg}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                `,
                confirmButtonText: 'Entendido, Completar Información',
                confirmButtonColor: '#4A5D23',
                background: '#FFFFFF',
                width: '560px'
              });
              return;
            }
            Swal.fire({
              title: "Bitácora Actualizada",
              text: "Los cambios han sido guardados exitosamente.",
              icon: "success",
              confirmButtonColor: "#4A5D23",
              timer: 2000
            });
            setIsSectionFormOpen(false);
            reloadLists();
          });
      } else {
        dispatch(registrarCoccion(payload))
          .then((res) => {
            if (res.error) {
              const errMsg = res.payload || res.error.message || "Error al registrar la cocción.";
              Swal.fire({
                title: '<div style="display:flex;align-items:center;justify-content:center;gap:10px;color:#991B1B;font-size:20px;font-weight:800;"><span style="font-size:24px;">⚠️</span> Inconsistencia o Dato Faltante</div>',
                html: `
                  <div style="text-align:left;font-family:inherit;">
                    <p style="margin:0 0 12px 0;color:#4B5563;font-size:13px;line-height:1.5;">
                      El servidor indicó la siguiente observación al procesar la <strong>Bitácora de Cocción</strong>:
                    </p>
                    <div style="background:#FFF5F5;border:1px solid #FECACA;border-radius:12px;padding:12px 14px;">
                      <div style="display:flex;align-items:flex-start;gap:10px;">
                        <span style="font-size:18px;line-height:1;margin-top:2px;">❌</span>
                        <div style="flex:1;">
                          <strong style="color:#991B1B;font-size:13px;display:block;">Validación Requerida</strong>
                          <span style="color:#6B7280;font-size:12px;line-height:1.4;display:block;margin-top:3px;">${errMsg}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                `,
                confirmButtonText: 'Entendido, Completar Información',
                confirmButtonColor: '#4A5D23',
                background: '#FFFFFF',
                width: '560px'
              });
              return;
            }
            Swal.fire({
              title: "¡Registro Exitoso!",
              text: finalEstatus === "borrador" ? "La bitácora de cocción se ha guardado como borrador." : "La bitácora de cocción ha sido enviada exitosamente a revisión oficial.",
              icon: "success",
              confirmButtonColor: "#4A5D23",
              timer: 2500
            });
            setIsSectionFormOpen(false);
            reloadLists();
          });
      }
    }

    const targetId = src.rawId || src.id || noProd;
    const existingIndex = productionLots.findIndex(l => l.id === targetId || l.noProduccion === noProd);

    if (existingIndex >= 0) {
      const existingLot = productionLots[existingIndex];
      const updatedLot = {
        ...existingLot,
        noProduccion: noProd,
        idUnidadProduccion: src.idUnidadProduccion || existingLot.idUnidadProduccion,
        unidadProduccion: src.unidadProduccion || existingLot.unidadProduccion,
        predio: src.predio || src.guiaPredio || existingLot.predio,
        tipoMaguey: tipoMagueySummary,
        magueyes: magueyesList,
        fechaActualizacion: new Date().toISOString().split('T')[0],
        statusUI: statusUI,
        coccion: {
          ...existingLot.coccion,
          fechaIngreso: src.fechaIngreso || existingLot.coccion?.fechaIngreso,
          guiaPredio: src.guiaPredio || existingLot.coccion?.guiaPredio,
          numPinas: numPinas,
          kgMagueyCrudo: kgCrudo,
          magueyes: magueyesList,
          pctArt: pctArt,
          noInforme: src.noInforme || "",
          tipoHorno: src.tipoHorno || "",
          fechaInicioCoccion: src.fechaInicioCoccion || existingLot.coccion?.fechaInicioCoccion,
          fechaFinCoccion: src.fechaFinCoccion || existingLot.coccion?.fechaFinCoccion,
          kgMagueyCocido: kgCocido,
          observaciones: src.observaciones || ""
        }
      };

      const newLots = [...productionLots];
      newLots[existingIndex] = updatedLot;
      setProductionLots(newLots);
    } else {
      const newLot = {
        id: noProd,
        noProduccion: noProd,
        idUnidadProduccion: src.idUnidadProduccion || "",
        unidadProduccion: src.unidadProduccion || "Palenque Tradicional Santiago Matatlán (UP-042)",
        predio: src.predio || src.guiaPredio || "Predio Registrado",
        tipoMaguey: tipoMagueySummary,
        magueyes: magueyesList,
        etapaActual: "coccion",
        statusUI: statusUI,
        fechaInicio: src.fechaIngreso || new Date().toISOString().split('T')[0],
        fechaActualizacion: src.fechaIngreso || new Date().toISOString().split('T')[0],
        inspector: "Pendiente de V.Bo. de Unidad de Inspección",
        observacionesInspector: "",
        coccion: {
          fechaIngreso: src.fechaIngreso || new Date().toISOString().split('T')[0],
          guiaPredio: src.guiaPredio || "",
          numPinas: numPinas,
          kgMagueyCrudo: kgCrudo,
          magueyes: magueyesList,
          pctArt: pctArt,
          noInforme: src.noInforme || "",
          tipoHorno: src.tipoHorno || "",
          fechaInicioCoccion: src.fechaInicioCoccion || new Date().toISOString().split('T')[0],
          fechaFinCoccion: src.fechaFinCoccion || new Date().toISOString().split('T')[0],
          kgMagueyCocido: kgCocido,
          observaciones: src.observaciones || ""
        }
      };
      setProductionLots(prev => [newLot, ...prev]);
    }

    setActiveModal(null);
    setIsSectionFormOpen(false);
    setFormSectionData({});

    Swal.fire({
      title: finalEstatus === "enviada" ? "¡Cocción Enviada!" : "¡Borrador Guardado!",
      html: `El lote <b>${noProd}</b> ha sido registrado con estatus <b>${finalEstatus.toUpperCase()}</b> y enviado para revisión del inspector asignado.`,
      icon: "success",
      confirmButtonColor: "#4A5D23"
    });
  };

  const handleOpenNewMolienda = (optionalCoccionOrMolienda = null) => {
    const acceptedList = (Array.isArray(coccionSectionRecords) ? coccionSectionRecords : []).filter(c => {
      const st = String(c.status || c.statusUI || '').toLowerCase();
      return st.includes('aceptad') || st.includes('aprobad');
    });

    const chosenLot = optionalCoccionOrMolienda;
    const existingMol = chosenLot?.molienda || (chosenLot?.totalTinas !== undefined || (Array.isArray(chosenLot?.items) && chosenLot?.items?.[0]?.contenedor) ? chosenLot : null);

    const today = new Date().toISOString().split('T')[0];

    if (existingMol && Array.isArray(existingMol.items) && existingMol.items.length > 0) {
      setSelectedLot(chosenLot);
      setFormSectionData({
        id: existingMol.id || chosenLot.id_bitacora_molienda || chosenLot.id,
        rawId: existingMol.id || chosenLot.id_bitacora_molienda || chosenLot.rawId || chosenLot.id,
        noProduccion: chosenLot.noProduccion || chosenLot.no_produccion || "",
        id_bitacora_coccion: existingMol.id_bitacora_coccion || chosenLot.id_bitacora_coccion || null,
        observaciones: existingMol.observaciones || chosenLot.observaciones || "",
        status: existingMol.status || existingMol.estatus || chosenLot.status || "enviada",
        items: existingMol.items.map((it, idx) => {
          const rawKg = parseFloat(String(it.kgMaguey || 0).replace(/[^\d.]/g, '')) || 0;
          const rawVolForm = parseFloat(String(it.volumenFormulado || 0).replace(/[^\d.]/g, '')) || 0;
          const rawVolMezcal = parseFloat(String(it.volumenMezcal || it.volumenOrdinario || 0).replace(/[^\d.]/g, '')) || 0;
          const rawPctMezcal = parseFloat(String(it.pctAlcMezcal || it.pctAlcOrdinario || 0).replace(/[^\d.]/g, '')) || 0;
          const rawVolColas = parseFloat(String(it.volumenColas || 0).replace(/[^\d.]/g, '')) || 0;
          const rawPctColas = parseFloat(String(it.pctAlcColas || 0).replace(/[^\d.]/g, '')) || 0;

          return {
            id: it.id || (Date.now() + idx),
            noProceso: it.noProceso || (idx + 1),
            fechaFermentacion: it.fechaFermentacion || today,
            contenedor: it.contenedor || `Tina ${idx + 1 < 10 ? '0' + (idx + 1) : idx + 1}`,
            kgMaguey: String(rawKg || ""),
            equipoMolienda: it.equipoMolienda || it.equipo_molienda || "",
            equipoFermentacion: it.equipoFermentacion || it.equipo_fermentacion || "",
            fechaFormulacion: it.fechaFormulacion || today,
            tipoFormulacion: it.tipoFormulacion || it.tipo_formulacion || "espontanea",
            metodoFormulacion: it.metodoFormulacion !== undefined && it.metodoFormulacion !== null ? it.metodoFormulacion : (it.metodo_formulacion || ""),
            volumenFormulado: String(rawVolForm || ""),
            fechaPrimeraDestilacion: it.fechaPrimeraDestilacion || today,
            volumenOrdinario: String(rawVolMezcal || ""),
            volumenMezcal: String(rawVolMezcal || ""),
            pctAlcOrdinario: String(rawPctMezcal || ""),
            pctAlcMezcal: String(rawPctMezcal || ""),
            volumenColas: String(rawVolColas || ""),
            pctAlcColas: String(rawPctColas || "")
          };
        })
      });
    } else {
      // Si se pasó explícitamente una cocción (ej. desde Cocción -> Iniciar Molienda), se preselecciona
      const chosenCoccion = optionalCoccionOrMolienda || null;

      if (chosenCoccion && !existingMol) {
        const bal = getCoccionMoliendaBalance(chosenCoccion, moliendaSectionRecords);
        if (bal.isAgotada) {
          Swal.fire({
            title: "Materia Prima Agotada",
            html: `El lote de cocción <b>${chosenCoccion.noProduccion}</b> ya ha procesado sus <b>${bal.totalKgCocidos.toLocaleString()} kg</b> al 100% en bitácoras de molienda previas y no cuenta con saldo disponible.`,
            icon: "warning",
            confirmButtonColor: "#4A5D23"
          });
          return;
        }
      }

      const bal = chosenCoccion ? getCoccionMoliendaBalance(chosenCoccion, moliendaSectionRecords) : { kgDisponibles: 0 };
      const initialKg = bal.kgDisponibles > 0 ? String(Math.min(2500, bal.kgDisponibles)) : "";

      setSelectedLot(chosenCoccion);
      setFormSectionData({
        id: null,
        rawId: null,
        noProduccion: chosenCoccion ? (chosenCoccion.noProduccion || chosenCoccion.no_produccion || "") : "",
        id_bitacora_coccion: chosenCoccion ? (chosenCoccion.rawId || chosenCoccion.id) : null,
        items: [
          {
            id: Date.now(),
            fechaFermentacion: today,
            contenedor: "Tina 01",
            kgMaguey: initialKg,
            equipoMolienda: "",
            equipoFermentacion: "",
            fechaFormulacion: today,
            tipoFormulacion: "espontanea",
            metodoFormulacion: "",
            volumenFormulado: initialKg ? String(Math.round(Number(initialKg) * 0.6)) : "",
            fechaPrimeraDestilacion: today,
            volumenOrdinario: initialKg ? String(Math.round(Number(initialKg) * 0.22)) : "",
            volumenMezcal: initialKg ? String(Math.round(Number(initialKg) * 0.22)) : "",
            pctAlcOrdinario: "",
            pctAlcMezcal: "",
            volumenColas: initialKg ? String(Math.round(Number(initialKg) * 0.03)) : "",
            pctAlcColas: ""
          }
        ],
        observaciones: "",
        status: "borrador"
      });
    }

    setActiveTab(2);
    setIsSectionFormOpen(true);
  };

  const handleOpenMolienda = (lot) => {
    handleOpenNewMolienda(lot);
  };

  const handleSaveMolienda = async (e, customStatus = "enviada", overrideFormData = null) => {
    if (e && e.preventDefault) e.preventDefault();
    const finalStatus = typeof e === 'string' ? e : (customStatus === "borrador" ? "borrador" : "enviada");
    const activeData = overrideFormData || (typeof customStatus === 'object' ? customStatus : null) || formSectionData || {};

    const noProdToUse = (activeData.noProduccion || "").trim();
    if (!noProdToUse) {
      Swal.fire("Campo Obligatorio", "Debe seleccionar una Bitácora de Cocción para continuar con la molienda.", "warning");
      return;
    }

    const targetCoccion = coccionSectionRecords.find(c => c.noProduccion === noProdToUse || String(c.rawId) === String(activeData.id_bitacora_coccion) || String(c.id) === String(activeData.id_bitacora_coccion));
    const idCoccionToUse = activeData.id_bitacora_coccion || targetCoccion?.rawId || targetCoccion?.id || null;

    const itemsToSave = activeData.items || [];
    if (itemsToSave.length === 0) {
      Swal.fire("Atención", "Debe registrar al menos una tina de fermentación.", "warning");
      return;
    }

    // Validar campos obligatorios por tina (Kg de Maguey Cocido) y rangos de alcohol
    for (let i = 0; i < itemsToSave.length; i++) {
      const it = itemsToSave[i];
      const kgVal = Number(String(it.kgMaguey || 0).replace(/[^\d.]/g, ''));
      if (!kgVal || kgVal <= 0) {
        Swal.fire({
          title: "Campo Obligatorio",
          html: `En la <b>${it.contenedor || 'Tina ' + (i + 1)}</b> el campo <b>Kg de Maguey Cocido</b> es obligatorio y debe ser mayor a 0.`,
          icon: "warning",
          confirmButtonColor: "#4A5D23"
        });
        return;
      }

      const pMez = Number(String(it.pctAlcMezcal || it.pctAlcOrdinario || 0).replace(/[^\d.]/g, ''));
      const pCol = Number(String(it.pctAlcColas || 0).replace(/[^\d.]/g, ''));
      if (pMez > 100 || pCol > 100) {
        Swal.fire({
          title: "Porcentaje de Alcohol Inválido",
          html: `En la <b>${it.contenedor || 'Tina ' + (i + 1)}</b> el % de alcohol no puede ser mayor a 100% (capturado: <b>${pMez > 100 ? pMez + '% en Ordinario' : pCol + '% en Colas'}</b>).<br><br>Por favor ingrese un porcentaje válido (ej. <b>26.5%</b> o <b>45%</b>).`,
          icon: "warning",
          confirmButtonColor: "#4A5D23"
        });
        return;
      }
    }

    const totalKg = itemsToSave.reduce((acc, item) => acc + (Number(String(item.kgMaguey).replace(/[^\d.]/g, '')) || 0), 0);

    // Validación estricta de saldo de maguey cocido disponible
    if (targetCoccion) {
      const balance = getCoccionMoliendaBalance(targetCoccion, moliendaSectionRecords, activeData.rawId || activeData.id);
      if (totalKg > balance.kgDisponibles && balance.kgDisponibles > 0) {
        Swal.fire({
          title: "Exceso de Materia Prima",
          html: `Has asignado <b>${totalKg.toLocaleString()} kg</b> en las tinas, superando el saldo disponible de <b>${balance.kgDisponibles.toLocaleString()} kg</b> en la cocción <b>${noProdToUse}</b> (Exceso: <b>${(totalKg - balance.kgDisponibles).toLocaleString()} kg</b>).<br><br>Por favor ajusta los kilogramos antes de guardar.`,
          icon: "warning",
          confirmButtonColor: "#4A5D23"
        });
        return;
      }
    }

    const payload = {
      id_login: idLogin,
      no_produccion: noProdToUse,
      id_bitacora_coccion: idCoccionToUse,
      observaciones: activeData.observaciones || "",
      estatus: finalStatus,
      items: itemsToSave
    };

    try {
      const recordId = activeData.id_bitacora_molienda || activeData.id || activeData.rawId;
      if (recordId) {
        await dispatch(actualizarMolienda({ id: recordId, moliendaData: payload })).unwrap();
      } else {
        await dispatch(registrarMolienda(payload)).unwrap();
      }

      if (idLogin) {
        dispatch(obtenerMoliendasPorLogin(idLogin));
        dispatch(obtenerCoccionesPorLogin({ id_login: idLogin, page: coccionPage, limit: coccionLimit }));
        dispatch(obtenerTrazabilidadAsociado({ id_login: idLogin, page: tracePage, limit: traceLimit }));
      }

      setActiveModal(null);
      setIsSectionFormOpen(false);

      if (finalStatus === "borrador") {
        Swal.fire({
          title: "¡Borrador Guardado!",
          html: `El borrador de Molienda para el lote <b>${noProdToUse}</b> se ha guardado exitosamente.`,
          icon: "info",
          confirmButtonColor: "#4A5D23"
        });
      } else {
        Swal.fire({
          title: "¡Molienda Registrada!",
          html: `La bitácora de Molienda para el lote <b>${noProdToUse}</b> ha sido enviada a la Unidad de Inspección con <b>${itemsToSave.length} tinas</b> (${totalKg.toLocaleString()} kg).`,
          icon: "success",
          confirmButtonColor: "#4A5D23"
        });
      }
    } catch (err) {
      console.error("Error guardando molienda:", err);
      Swal.fire("Error", err?.message || "No se pudo registrar la molienda.", "error");
    }
  };

  const handleCancelMolienda = (rec) => {
    Swal.fire({
      title: "¿Desea cancelar esta bitácora?",
      text: `La bitácora de molienda "${rec.noProduccion || rec.id}" pasará a estatus CANCELADA.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Sí, cancelar bitácora",
      cancelButtonText: "No, volver"
    }).then((result) => {
      if (result.isConfirmed) {
        const idMolienda = rec.rawId || rec.idBitacoraMolienda || (typeof rec.id === 'number' ? rec.id : null);
        if (idMolienda) {
          dispatch(actualizarMolienda({ id: idMolienda, moliendaData: { estatus: "cancelada" } }))
            .then(() => {
              if (idLogin) {
                dispatch(obtenerMoliendasPorLogin(idLogin));
                dispatch(obtenerTrazabilidadAsociado(idLogin));
              }
              Swal.fire({
                title: "Bitácora Cancelada",
                text: "El registro de molienda ha sido marcado como cancelado exitosamente.",
                icon: "success",
                confirmButtonColor: "#4A5D23"
              });
            })
            .catch((err) => {
              Swal.fire("Error", err?.message || "No se pudo cancelar el registro.", "error");
            });
        } else {
          if (idLogin) {
            dispatch(obtenerMoliendasPorLogin(idLogin));
          }
          Swal.fire("Cancelada", "La bitácora ha sido cancelada.", "success");
        }
      }
    });
  };

  const handleOpenNewDestilacion = (moliendaOrDestLot = null) => {
    const today = new Date().toISOString().split('T')[0];
    const chosenLot = moliendaOrDestLot || null;
    const noProdToUse = chosenLot ? (chosenLot.noProduccion || chosenLot.no_produccion || "") : "";

    // Verificar si ya tiene datos de destilación para edición
    const existingDest = chosenLot?.destilacion || (chosenLot?.totalAlambiques !== undefined ? chosenLot : null);

    if (existingDest && Array.isArray(existingDest.items) && existingDest.items.length > 0) {
      setSelectedLot(chosenLot);
      setFormSectionData({
        id: existingDest.id || chosenLot.id_bitacora_destilacion || chosenLot.id,
        rawId: existingDest.id || chosenLot.id_bitacora_destilacion || chosenLot.rawId || chosenLot.id,
        noProduccion: noProdToUse,
        id_bitacora_molienda: existingDest.id_bitacora_molienda || chosenLot.id_bitacora_molienda || (chosenLot.molienda ? (chosenLot.molienda.rawId || chosenLot.molienda.id) : null),
        observaciones: existingDest.observaciones || chosenLot.observaciones || "",
        status: existingDest.status || existingDest.estatus || chosenLot.status || "enviada",
        items: existingDest.items.map((it, idx) => {
          const rawVolADestilar = parseFloat(String(it.volADestilar || it.volumenADestilar || 0).replace(/[^\d.]/g, '')) || 0;
          const rawPuntasVol = parseFloat(String(it.puntasVol || it.puntasVolumen || 0).replace(/[^\d.]/g, '')) || 0;
          const rawPuntasAlc = parseFloat(String(it.puntasAlc || it.puntasPctAlc || 0).replace(/[^\d.]/g, '')) || 0;
          const rawMezcalVol = parseFloat(String(it.mezcalVol || it.mezcalVolumen || 0).replace(/[^\d.]/g, '')) || 0;
          const rawMezcalAlc = parseFloat(String(it.mezcalAlc || it.mezcalPctAlc || 0).replace(/[^\d.]/g, '')) || 0;
          const rawColasVol = parseFloat(String(it.colasVol || it.colasVolumen || 0).replace(/[^\d.]/g, '')) || 0;
          const rawColasAlc = parseFloat(String(it.colasAlc || it.colasPctAlc || 0).replace(/[^\d.]/g, '')) || 0;

          return {
            id: it.id || (Date.now() + idx),
            fechaSegunda: it.fechaSegunda || it.fechaSegundaDestilacion || today,
            destiladorNum: it.destiladorNum || `Alambique ${idx + 1 < 10 ? '0' + (idx + 1) : idx + 1}`,
            tipoAlambique: it.tipoAlambique || it.tipo_alambique || "",
            nuevoLote: it.nuevoLote || "",
            volADestilar: String(rawVolADestilar || ""),
            esDestiladoCon: Boolean(it.esDestiladoCon),
            destiladoConIngrediente: it.destiladoConIngrediente || "",
            destiladoConIngredientes: Array.isArray(it.destiladoConIngredientes) ? it.destiladoConIngredientes : (it.destiladoConIngrediente ? String(it.destiladoConIngrediente).split(',').map(s => s.trim()) : []),
            puntasVol: String(rawPuntasVol || ""),
            puntasAlc: String(rawPuntasAlc || ""),
            mezcalVol: String(rawMezcalVol || ""),
            mezcalAlc: String(rawMezcalAlc || ""),
            colasVol: String(rawColasVol || ""),
            colasAlc: String(rawColasAlc || "")
          };
        })
      });
    } else {
      const targetCoccion = (Array.isArray(coccionSectionRecords) ? coccionSectionRecords : []).find(c =>
        (noProdToUse && String(c.noProduccion || c.no_produccion || c.id || '').trim().toLowerCase() === String(noProdToUse).trim().toLowerCase()) ||
        (chosenLot?.id_bitacora_coccion && String(c.rawId || c.id) === String(chosenLot.id_bitacora_coccion)) ||
        (chosenLot?.molienda?.id_bitacora_coccion && String(c.rawId || c.id) === String(chosenLot.molienda.id_bitacora_coccion))
      ) || chosenLot?.coccion || null;

      const autoKg = extractKgAgaveCrudo(targetCoccion) || (chosenLot?.coccion ? extractKgAgaveCrudo(chosenLot.coccion) : 0);
      const initialKgCrudo = autoKg > 0 ? autoKg : "";
      const initialArt = targetCoccion ? (targetCoccion.pctArt || targetCoccion.pct_art || "") : (chosenLot?.coccion?.pctArt || "");

      // Generar automáticamente los 2 registros de destilación (uno de Mezcal y uno de Ordinario)
      const generatedItems = chosenLot
        ? createDestilacionItemsFromMolienda(chosenLot, today)
        : createDestilacionItemsFromMolienda(null, today);

      setSelectedLot(chosenLot);
      setFormSectionData({
        id: null,
        rawId: null,
        noProduccion: noProdToUse,
        id_bitacora_molienda: chosenLot ? (chosenLot.rawId || chosenLot.idBitacoraMolienda || chosenLot.id_bitacora_molienda || (chosenLot.molienda ? (chosenLot.molienda.rawId || chosenLot.molienda.id) : null)) : null,
        kgAgave: initialKgCrudo ? String(initialKgCrudo) : "",
        pctArt: initialArt ? String(initialArt) : "",
        observaciones: "",
        status: "borrador",
        items: generatedItems
      });
    }

    setActiveTab(3);
    setIsSectionFormOpen(true);
  };

  const handleOpenDestilacion = (lot) => {
    handleOpenNewDestilacion(lot);
  };

  const handleSaveDestilacion = async (e, customStatus = "enviada", overrideFormData = null) => {
    if (e && e.preventDefault) e.preventDefault();
    const finalStatus = typeof e === 'string' ? e : (customStatus === "borrador" ? "borrador" : "enviada");
    const activeData = overrideFormData || (typeof customStatus === 'object' ? customStatus : null) || formSectionData || {};

    const noProdToUse = (activeData.noProduccion || selectedLot?.noProduccion || "").trim();
    if (!noProdToUse) {
      Swal.fire("Campo Obligatorio", "Debe seleccionar un Lote de Molienda para continuar con la destilación.", "warning");
      return;
    }

    const itemsToSave = activeData.items || [];
    if (itemsToSave.length === 0) {
      Swal.fire("Atención", "Debe registrar al menos un alambique / destilador.", "warning");
      return;
    }

    // Validar % de alcohol entre 0 y 100
    for (let i = 0; i < itemsToSave.length; i++) {
      const it = itemsToSave[i];
      const pMez = Number(String(it.mezcalAlc || 0).replace(/[^\d.]/g, ''));
      const pPun = Number(String(it.puntasAlc || 0).replace(/[^\d.]/g, ''));
      const pCol = Number(String(it.colasAlc || 0).replace(/[^\d.]/g, ''));
      if (pMez > 100 || pPun > 100 || pCol > 100) {
        Swal.fire({
          title: "Porcentaje de Alcohol Inválido",
          html: `En el <b>${it.destiladorNum || 'Alambique ' + (i + 1)}</b> el % de alcohol no puede ser mayor a 100%.<br><br>Por favor ingrese un porcentaje válido (ej. <b>48.5%</b>).`,
          icon: "warning",
          confirmButtonColor: "#4A5D23"
        });
        return;
      }
    }

    const totalMezcal = itemsToSave.reduce((acc, item) => acc + (Number(String(item.mezcalVol || 0).replace(/[^\d.]/g, '')) || 0), 0);

    const totalAlcPure = itemsToSave.reduce((acc, item) => {
      const v = Number(String(item.mezcalVol || 0).replace(/[^\d.]/g, '')) || 0;
      const a = Number(String(item.mezcalAlc || 0).replace(/[^\d.]/g, '')) || 0;
      return acc + (v * a);
    }, 0);
    const avgAlc = totalMezcal > 0 ? (totalAlcPure / totalMezcal).toFixed(1) : "48.5";

    const payload = {
      id_login: idLogin,
      no_produccion: noProdToUse,
      id_bitacora_molienda: activeData.id_bitacora_molienda || selectedLot?.id_bitacora_molienda || null,
      observaciones: activeData.observaciones || "",
      estatus: finalStatus,
      items: itemsToSave,
      kg_agave: activeData.kgAgave || activeData.kg_agave || null,
      pct_art: activeData.pctArt || activeData.pct_art || null,
      rendimiento_real: activeData.rendimientoReal || activeData.rendimiento_real || null,
      rendimiento_teorico: activeData.rendimientoTeorico || activeData.rendimiento_teorico || null,
      eficiencia_pct: activeData.eficienciaPct || activeData.eficiencia_pct || null
    };

    try {
      const recordId = activeData.id_bitacora_destilacion || activeData.rawId || (typeof activeData.id === 'number' ? activeData.id : null);
      if (recordId) {
        await dispatch(actualizarDestilacion({ id: recordId, destilacionData: payload })).unwrap();
      } else {
        await dispatch(registrarDestilacion(payload)).unwrap();
      }

      if (idLogin) {
        dispatch(obtenerDestilacionesPorLogin(idLogin));
        dispatch(obtenerMoliendasPorLogin(idLogin));
        dispatch(obtenerCoccionesPorLogin({ id_login: idLogin, page: coccionPage, limit: coccionLimit }));
        dispatch(obtenerTrazabilidadAsociado({ id_login: idLogin, page: tracePage, limit: traceLimit }));
      }

      setActiveModal(null);
      setIsSectionFormOpen(false);

      if (finalStatus === "borrador") {
        Swal.fire({
          title: "¡Borrador Guardado!",
          html: `El borrador de Destilación para el lote <b>${noProdToUse}</b> se ha guardado exitosamente.`,
          icon: "info",
          confirmButtonColor: "#4A5D23"
        });
      } else {
        Swal.fire({
          title: "¡Destilación Registrada!",
          html: `La bitácora de Destilación para el lote <b>${noProdToUse}</b> ha sido enviada a la Unidad de Inspección con <b>${itemsToSave.length} alambiques</b> (${totalMezcal.toLocaleString()} L de mezcal obtenido a ${avgAlc}% alc.).`,
          icon: "success",
          confirmButtonColor: "#4A5D23"
        });
      }
    } catch (err) {
      console.error("Error guardando destilación:", err);
      Swal.fire("Error", err?.message || "No se pudo registrar la destilación.", "error");
    }
  };

  const handleCancelDestilacion = (rec) => {
    Swal.fire({
      title: "¿Desea cancelar esta bitácora?",
      text: `La bitácora de destilación "${rec.noProduccion || rec.id}" pasará a estatus CANCELADA.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Sí, cancelar bitácora",
      cancelButtonText: "No, volver"
    }).then((result) => {
      if (result.isConfirmed) {
        const noProd = rec.noProduccion;
        const updatedLots = productionLots.map(l => {
          if (l.noProduccion === noProd || l.id === rec.id) {
            return {
              ...l,
              destilacion: l.destilacion ? { ...l.destilacion, status: "cancelada" } : null,
              statusUI: "cancelada"
            };
          }
          return l;
        });
        setProductionLots(updatedLots);
        Swal.fire("Cancelada", "La bitácora de destilación ha sido cancelada exitosamente.", "success");
      }
    });
  };

  const handleOpenGranel = (lot) => {
    setSelectedLot(lot);
    const today = new Date().toISOString().split('T')[0];
    const mezcalVol = lot?.destilacion?.totalMezcalObtenido || 300;
    const mezcalAlc = lot?.destilacion?.avgAlcMezcal || 48.5;
    const noProd = lot?.noProduccion || lot?.noLote || "";

    setFormSectionData({
      id: null,
      idContenedor: "",
      no_tanque: "",
      noLote: noProd,
      no_lote: noProd,
      categoria: lot?.categoria || "Mezcal Artesanal",
      clase: lot?.destilacion?.esDestiladoCon ? "Destilado con" : "Blanco Joven",
      fechaMovimiento: today,
      fecha: today,
      noAnalisis: "",
      clave_fq: "",
      tipoMaguey: lot?.tipoMaguey || lot?.especie || "",
      especie: lot?.tipoMaguey || lot?.especie || "",
      ingredientes: lot?.destilacion?.destiladoConIngrediente || "",
      ingrediente: lot?.destilacion?.destiladoConIngrediente || "",
      litros: String(mezcalVol),
      porcentaje_alc_vol: String(mezcalAlc),
      invInicialVol: String(mezcalVol),
      invInicialAlc: String(mezcalAlc),
      volAguaAjuste: "0",
      entradaVolumen: String(mezcalVol),
      entradaAlc: String(mezcalAlc),
      entradaProcedencia: `Destilación ${noProd}`,
      salidaVolumen: "0",
      salidaAlc: "0",
      salidaDestino: "",
      invFinalVol: String(mezcalVol),
      invFinalAlc: String(mezcalAlc),
      observaciones: "Ingreso a inventario de mezcal a granel para custodia y reposo.",
      status: "borrador"
    });

    setActiveTab(4);
    setIsSectionFormOpen(true);
  };

  const handleSaveGranel = (statusOrEvent, customStatus = "aprobado", optionalData = null) => {
    if (statusOrEvent && statusOrEvent.preventDefault) statusOrEvent.preventDefault();
    const activeData = optionalData || (typeof customStatus === 'object' ? customStatus : null) || formSectionData || {};

    const targetLote = activeData.noLote || activeData.no_lote || selectedLot?.noProduccion || `GRANEL-${Date.now().toString().slice(-4)}`;
    const finalStatus = typeof customStatus === 'string' ? customStatus : (activeData.status || "aprobado");
    const isBorrador = finalStatus === "borrador";
    const statusUI = isBorrador ? "borrador_ui" : "aprobado_ui";

    const volMezcal = String(activeData.litros || activeData.invFinalVol || activeData.entradaVolumen || "0").replace(/[^\d.]/g, '');
    const alcMezcal = String(activeData.porcentaje_alc_vol || activeData.invFinalAlc || activeData.entradaAlc || "0").replace(/[^\d.]/g, '');

    const newGranelRecord = {
      id: activeData.id || targetLote,
      noLote: targetLote,
      no_lote: targetLote,
      idContenedor: activeData.idContenedor || activeData.no_tanque || "",
      no_tanque: activeData.no_tanque || activeData.idContenedor || "",
      categoria: activeData.categoria || "Mezcal Artesanal",
      clase: activeData.clase || "Blanco Joven",
      fechaMovimiento: activeData.fechaMovimiento || activeData.fecha || new Date().toISOString().split('T')[0],
      fecha: activeData.fecha || activeData.fechaMovimiento || new Date().toISOString().split('T')[0],
      noAnalisisFisicoquimico: activeData.clave_fq || activeData.noAnalisis || "",
      noAnalisis: activeData.clave_fq || activeData.noAnalisis || "",
      clave_fq: activeData.clave_fq || activeData.noAnalisis || "",
      tipoMaguey: activeData.tipoMaguey || activeData.especie || "",
      especie: activeData.especie || activeData.tipoMaguey || "",
      ingredientes: activeData.ingredientes || activeData.ingrediente || "",
      ingrediente: activeData.ingrediente || activeData.ingredientes || "",
      litros: parseFloat(volMezcal) || 0,
      porcentaje_alc_vol: parseFloat(alcMezcal) || 0,
      invInicialVol: volMezcal,
      invInicialAlc: alcMezcal,
      entradaProcedencia: activeData.entradaProcedencia || `2da Destilación (Lote ${targetLote})`,
      entradaVolumen: volMezcal,
      entradaAlc: alcMezcal,
      salidaDestino: activeData.salidaDestino || "",
      salidaVolumen: String(activeData.salidaVolumen || "0").replace(/[^\d.]/g, ''),
      salidaAlc: String(activeData.salidaAlc || "0").replace(/[^\d.]/g, ''),
      invFinalVol: volMezcal,
      invFinalAlc: alcMezcal,
      observaciones: activeData.observaciones || "",
      inspector: activeData.inspector || "Ing. Carlos Mendoza (UI Autorizado)",
      no_barricas: activeData.no_barricas || activeData.noBarricas || "",
      noBarricas: activeData.no_barricas || activeData.noBarricas || "",
      id_bitacora_maduracion: activeData.id_bitacora_maduracion || null,
      id_unidad_produccion: activeData.id_unidad_produccion || null,
      instalacion: activeData.instalacion || activeData.instalacionOrigen || "",
      status: finalStatus,
      statusUI: statusUI
    };

    // Actualizar customGranelRecords
    setCustomGranelRecords(prev => {
      const idx = prev.findIndex(r => r.id === newGranelRecord.id || r.noLote === newGranelRecord.noLote);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = newGranelRecord;
        return copy;
      }
      return [newGranelRecord, ...prev];
    });

    // Actualizar en productionLots si existe
    setProductionLots(prev => {
      const existingIdx = prev.findIndex(l => l.noProduccion === targetLote || l.id === targetLote);
      if (existingIdx >= 0) {
        const copy = [...prev];
        copy[existingIdx] = {
          ...copy[existingIdx],
          etapaActual: "granel",
          statusUI: statusUI,
          fechaActualizacion: new Date().toISOString().split('T')[0],
          granel: newGranelRecord
        };
        return copy;
      }
      return prev;
    });

    setIsSectionFormOpen(false);
    setFormSectionData({});

    if (idLogin) {
      const payloadBackend = {
        id_login: idLogin,
        no_lote: targetLote,
        no_tanque: newGranelRecord.no_tanque,
        categoria: newGranelRecord.categoria,
        clase: newGranelRecord.clase,
        especie: newGranelRecord.especie,
        ingrediente: newGranelRecord.ingrediente,
        litros: newGranelRecord.litros,
        porcentaje_alc_vol: newGranelRecord.porcentaje_alc_vol,
        fecha: newGranelRecord.fecha,
        estatus: finalStatus,
        observaciones: newGranelRecord.observaciones,
        clave_fq: newGranelRecord.clave_fq
      };
      dispatch(registrarGranel(payloadBackend)).then(res => {
        if (res?.meta?.requestStatus === "fulfilled") {
          const target = String(targetLote).trim();
          setCustomGranelRecords(prev => prev.filter(r => {
            const rLote = String(r.noLote || r.no_lote || "").trim();
            return r.id !== newGranelRecord.id && (!rLote || rLote !== target);
          }));
          dispatch(obtenerGranelesPorLogin(idLogin));
        }
      });
    }

    Swal.fire({
      title: isBorrador ? "¡Borrador Guardado!" : "¡Movimiento Guardado!",
      html: `El registro de mezcal a granel para el lote <b>${targetLote}</b> en <b>${activeData.idContenedor || 'Contenedor'}</b> ha sido guardado exitosamente.`,
      icon: "success",
      confirmButtonColor: "#059669"
    });
  };

  const handleSaveFusion = (newGranelData, validSources, finalStatus = "aprobado") => {
    // 1. Descontar volúmenes extraídos en los registros origen
    setCustomGranelRecords(prev => {
      // Actualizar los que ya están en customGranelRecords
      const updatedExisting = prev.map(rec => {
        const matchingSrc = validSources.find(s => s.granelId === rec.id || s.granelId === rec.noLote || s.granelId === rec.idContenedor);
        if (matchingSrc) {
          const extraido = parseFloat(matchingSrc.volExtraer) || 0;
          const currentFinal = parseFloat(String(rec.invFinalVol || rec.entradaVolumen || rec.litros || 0).replace(/[^\d.]/g, '')) || 0;
          const newFinal = Math.max(0, currentFinal - extraido);
          const currentSalida = parseFloat(String(rec.salidaVolumen || 0).replace(/[^\d.]/g, '')) || 0;
          const motivo = validSources.length === 1
            ? `Extracción a nuevo lote: ${newGranelData.noLote}`
            : `Extracción para mezcla: ${newGranelData.noLote}`;

          return {
            ...rec,
            salidaDestino: rec.salidaDestino ? `${rec.salidaDestino} | ${motivo}` : motivo,
            salidaVolumen: String(currentSalida + extraido),
            salidaAlc: rec.invFinalAlc || rec.entradaAlc || "48.5",
            invFinalVol: String(newFinal),
            litros: newFinal
          };
        }
        return rec;
      });

      // Para cualquier lote origen que no estuviera en customGranelRecords pero sí en granelSectionRecords
      const newlyDiscounted = [];
      validSources.forEach(s => {
        const alreadyInUpdated = updatedExisting.some(r => r.id === s.granelId || r.noLote === s.granelId || r.idContenedor === s.granelId);
        if (!alreadyInUpdated) {
          const found = (granelSectionRecords || []).find(r => r.id === s.granelId || r.noLote === s.granelId || r.idContenedor === s.granelId);
          if (found) {
            const extraido = parseFloat(s.volExtraer) || 0;
            const currentFinal = parseFloat(String(found.invFinalVol || found.entradaVolumen || found.litros || 0).replace(/[^\d.]/g, '')) || 0;
            const newFinal = Math.max(0, currentFinal - extraido);
            const currentSalida = parseFloat(String(found.salidaVolumen || 0).replace(/[^\d.]/g, '')) || 0;
            const motivo = validSources.length === 1
              ? `Extracción a nuevo lote: ${newGranelData.noLote}`
              : `Extracción para mezcla: ${newGranelData.noLote}`;

            newlyDiscounted.push({
              ...found,
              salidaDestino: found.salidaDestino ? `${found.salidaDestino} | ${motivo}` : motivo,
              salidaVolumen: String(currentSalida + extraido),
              salidaAlc: found.invFinalAlc || found.entradaAlc || "48.5",
              invFinalVol: String(newFinal),
              litros: newFinal
            });
          }
        }
      });

      // 2. Agregar el nuevo registro consolidado / extraído de la mezcla
      const recordWithSources = {
        ...newGranelData,
        origenFuentes: newGranelData.origenFuentes || validSources.map(s => ({
          granelId: s.granelId,
          volExtraer: parseFloat(s.volExtraer) || 0
        })),
        esFusionOExtraccion: true
      };

      return [recordWithSources, ...newlyDiscounted, ...updatedExisting];
    });

    // 3. Sincronizar en productionLots si existe
    setProductionLots(prev => {
      return prev.map(lot => {
        const matchingSrc = validSources.find(s => s.granelId === lot.noProduccion || s.granelId === lot.id || s.granelId === lot.granel?.noLote);
        if (matchingSrc && lot.granel) {
          const extraido = parseFloat(matchingSrc.volExtraer) || 0;
          const currentFinal = parseFloat(String(lot.granel.invFinalVol || lot.granel.volInicial || 0).replace(/[^\d.]/g, '')) || 0;
          const newFinal = Math.max(0, currentFinal - extraido);
          const currentSalida = parseFloat(String(lot.granel.salidaVolumen || 0).replace(/[^\d.]/g, '')) || 0;

          return {
            ...lot,
            granel: {
              ...lot.granel,
              salidaDestino: `Extracción: ${newGranelData.noLote}`,
              salidaVolumen: String(currentSalida + extraido),
              invFinalVol: String(newFinal),
              volFinal: newFinal
            }
          };
        }
        return lot;
      });
    });

    // 4. Persistir la fusión / extracción en la base de datos (BackendInspeccion)
    if (idLogin) {
      const payloadBackend = {
        id_login: idLogin,
        no_lote: newGranelData.noLote,
        no_tanque: newGranelData.idContenedor || newGranelData.no_tanque,
        categoria: newGranelData.categoria,
        clase: newGranelData.clase,
        especie: newGranelData.tipoMaguey || newGranelData.especie,
        ingrediente: newGranelData.ingredientes || newGranelData.ingrediente,
        litros: parseFloat(newGranelData.invFinalVol) || 0,
        porcentaje_alc_vol: parseFloat(newGranelData.invFinalAlc) || 0,
        fecha: newGranelData.fechaMovimiento || newGranelData.fecha || new Date().toISOString(),
        estatus: finalStatus,
        observaciones: newGranelData.observaciones || "",
        fuentes: validSources.map(s => ({
          id_granel_origen: s.id || s.id_bitacora_granel || null,
          granelId: s.granelId,
          volExtraer: parseFloat(s.volExtraer) || 0,
          no_lote_origen: s.noLote || s.granelId
        }))
      };

      dispatch(registrarFusionGranel(payloadBackend)).then((actionResult) => {
        if (actionResult?.meta?.requestStatus === "fulfilled") {
          const savedLote = String(newGranelData.noLote || newGranelData.no_lote || "").trim();
          setCustomGranelRecords(prev => prev.filter(r => {
            const rLote = String(r.noLote || r.no_lote || "").trim();
            return r.id !== newGranelData.id && (!rLote || rLote !== savedLote);
          }));
          dispatch(obtenerGranelesPorLogin(idLogin));
        }
      });
    }
  };

  const handleUndoGranel = (recordToUndo) => {
    if (!recordToUndo) return;
    const isBorrador = String(recordToUndo.status || recordToUndo.statusUI || '').toLowerCase().includes('borrador');
    if (!isBorrador) {
      Swal.fire({
        title: "Operación no permitida",
        text: "Solo es posible deshacer movimientos que se encuentren en estado de Borrador.",
        icon: "warning",
        confirmButtonColor: "#7C3AED"
      });
      return;
    }

    // Identificar las fuentes de extracción
    let fuentes = Array.isArray(recordToUndo.origenFuentes) && recordToUndo.origenFuentes.length > 0
      ? recordToUndo.origenFuentes
      : [];

    // Fallback: Si no tiene origenFuentes pero entradaProcedencia dice "Extracción parcial de lote origen XXX"
    if (fuentes.length === 0 && recordToUndo.entradaProcedencia && recordToUndo.entradaProcedencia.includes("lote origen")) {
      const match = recordToUndo.entradaProcedencia.match(/lote origen\s+([^\s,]+)/i);
      if (match && match[1]) {
        const vol = parseFloat(String(recordToUndo.invFinalVol || recordToUndo.entradaVolumen || 0).replace(/[^\d.]/g, '')) || 0;
        fuentes = [{ granelId: match[1].trim(), volExtraer: vol }];
      }
    }

    const hasSources = fuentes.length > 0;
    const sourcesSummary = hasSources
      ? fuentes.map(s => `<b>${s.volExtraer} L</b> al lote <b>${s.granelId}</b>`).join(', ')
      : '';

    Swal.fire({
      title: "¿Deshacer movimiento en borrador?",
      html: `
        <div style="text-align: left; font-size: 13.5px; color: #334155; line-height: 1.5;">
          <p>Está a punto de cancelar y deshacer el registro en borrador del lote <strong>${recordToUndo.noLote || recordToUndo.idContenedor || 'Granel'}</strong>.</p>
          ${hasSources ? `
            <div style="background: #F0FDF4; border: 1px solid #BBF7D0; border-radius: 8px; padding: 10px 12px; margin-top: 10px;">
              <strong style="color: #166534;">Reintegro de volumen garantizado:</strong>
              <p style="margin: 4px 0 0 0; color: #15803D;">
                Se reintegrarán ${sourcesSummary}.
              </p>
            </div>
          ` : `
            <div style="background: #FEF2F2; border: 1px solid #FECACA; border-radius: 8px; padding: 10px 12px; margin-top: 10px; color: #991B1B;">
              El registro en borrador será eliminado del inventario a granel.
            </div>
          `}
          <p style="margin-top: 12px; font-size: 12px; color: #64748B;">* Esta acción devolverá los saldos de volumen inmediatamente al lote de origen.</p>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#64748B",
      confirmButtonText: "Sí, deshacer y regresar volumen",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (!result.isConfirmed) return;

      // 1. Reintegrar en customGranelRecords
      setCustomGranelRecords(prev => {
        // Filtrar el registro en borrador que se deshace
        const remaining = prev.filter(r => r.id !== recordToUndo.id && r.noLote !== recordToUndo.noLote);

        if (!hasSources) {
          return remaining;
        }

        // Devolver volumen a cada lote de origen
        return remaining.map(rec => {
          const matchingSources = fuentes.filter(s => s.granelId === rec.id || s.granelId === rec.noLote || s.granelId === rec.idContenedor);
          if (matchingSources.length > 0) {
            const volDevolver = matchingSources.reduce((acc, s) => acc + (parseFloat(s.volExtraer) || 0), 0);
            const currentFinal = parseFloat(String(rec.invFinalVol || rec.entradaVolumen || rec.litros || 0).replace(/[^\d.]/g, '')) || 0;
            const newFinal = currentFinal + volDevolver;
            const currentSalida = parseFloat(String(rec.salidaVolumen || 0).replace(/[^\d.]/g, '')) || 0;
            const newSalida = Math.max(0, currentSalida - volDevolver);

            // Limpiar la mención del lote deshecho en salidaDestino
            let newSalidaDestino = (rec.salidaDestino || '')
              .split('|')
              .map(p => p.trim())
              .filter(p => !p.includes(recordToUndo.noLote || recordToUndo.id))
              .join(' | ');

            return {
              ...rec,
              salidaDestino: newSalidaDestino,
              salidaVolumen: String(newSalida),
              invFinalVol: String(newFinal),
              litros: newFinal
            };
          }
          return rec;
        });
      });

      // 2. Reintegrar en productionLots si corresponde
      if (hasSources) {
        setProductionLots(prev => {
          return prev.map(lot => {
            const matchingSources = fuentes.filter(s => s.granelId === lot.noProduccion || s.granelId === lot.id || s.granelId === lot.granel?.noLote);
            if (matchingSources.length > 0 && lot.granel) {
              const volDevolver = matchingSources.reduce((acc, s) => acc + (parseFloat(s.volExtraer) || 0), 0);
              const currentFinal = parseFloat(String(lot.granel.invFinalVol || lot.granel.volInicial || 0).replace(/[^\d.]/g, '')) || 0;
              const newFinal = currentFinal + volDevolver;
              const currentSalida = parseFloat(String(lot.granel.salidaVolumen || 0).replace(/[^\d.]/g, '')) || 0;
              const newSalida = Math.max(0, currentSalida - volDevolver);

              let newSalidaDestino = (lot.granel.salidaDestino || '')
                .split('|')
                .map(p => p.trim())
                .filter(p => !p.includes(recordToUndo.noLote || recordToUndo.id))
                .join(' | ');

              return {
                ...lot,
                granel: {
                  ...lot.granel,
                  salidaDestino: newSalidaDestino,
                  salidaVolumen: String(newSalida),
                  invFinalVol: String(newFinal),
                  volFinal: newFinal
                }
              };
            }
            return lot;
          });
        });
      }

      // 3. Persistir en backend la reversión del movimiento en borrador
      const targetId = recordToUndo.id_bitacora_granel || recordToUndo.id;
      if (targetId) {
        dispatch(deshacerMovimientoGranel(targetId)).then((res) => {
          if (res?.meta?.requestStatus === "fulfilled") {
            if (idLogin) dispatch(obtenerGranelesPorLogin(idLogin));
          }
        });
      }

      Swal.fire({
        title: "¡Movimiento Deshecho!",
        html: `El movimiento del lote <b>${recordToUndo.noLote || recordToUndo.idContenedor}</b> ha sido deshecho ${hasSources ? 'y su volumen ha sido reintegrado exitosamente al lote de origen' : 'exitosamente'}.`,
        icon: "success",
        confirmButtonColor: "#059669"
      });
    });
  };

  // Manejador para Traslado de Granel entre Instalaciones
  const handleSaveTraslado = (trasladoData) => {
    if (!trasladoData) return;
    const vol = parseFloat(trasladoData.volumen || trasladoData.litros_traslado || 0);

    setCustomGranelRecords(prev => {
      return prev.map(rec => {
        if (rec.id === trasladoData.id_granel_origen || rec.noLote === trasladoData.no_lote_origen) {
          const newMov = {
            id_movimiento: Date.now(),
            tipo_movimiento: "traslado",
            litros_transferidos: vol,
            porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
            instalacion_origen: rec.instalacion || "Instalación Origen",
            instalacion_destino: trasladoData.instalacion_destino || "",
            folio_documento: trasladoData.folio_documento || "",
            motivo: `Traslado pendiente de validación por UI: hacia ${trasladoData.instalacion_destino || "otra instalación"}`,
            fecha: trasladoData.fecha || new Date().toISOString().split("T")[0],
            observaciones: trasladoData.observaciones || `Solicitud de traslado de ${vol} L a ${trasladoData.instalacion_destino}. Tanque destino: ${trasladoData.no_tanque_destino || "N/A"}. En espera de validación UI.`,
            es_pendiente: true,
            estado_ui: "Pendiente UI"
          };

          return {
            ...rec,
            estatus: "revision",
            status: "revision",
            statusUI: "revision",
            tieneTrasladoPendiente: true,
            trasladoPendiente: newMov,
            movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])],
            observaciones: `${rec.observaciones || ""} | [SOLICITUD TRASLADO PENDIENTE UI]: Solicitud de traslado de ${vol} L a ${trasladoData.instalacion_destino} (Tanque: ${trasladoData.no_tanque_destino || "N/A"}).`
          };
        }
        return rec;
      });
    });

    if (idLogin) {
      dispatch(registrarTrasladoGranel({ ...trasladoData, id_login: idLogin })).then(res => {
        if (res?.meta?.requestStatus === "fulfilled") {
          dispatch(obtenerGranelesPorLogin(idLogin));
        }
      });
    }
  };

  // Manejador para Dilución o Ajuste de Grado Alcohólico
  const handleSaveDilucion = (dilucionData) => {
    if (!dilucionData) return;
    const agua = parseFloat(dilucionData.agua_agregada || dilucionData.aguaAgregada || 0);
    const grado = parseFloat(dilucionData.grado_objetivo || dilucionData.gradoObjetivo || 0);

    setCustomGranelRecords(prev => {
      return prev.map(rec => {
        if (rec.id === dilucionData.id_granel_origen || rec.noLote === dilucionData.no_lote_origen) {
          // El volumen oficial se mantendrá hasta que la Unidad de Inspección valide y apruebe
          const newMov = {
            id_movimiento: Date.now(),
            tipo_movimiento: "dilucion",
            agua_agregada: agua,
            grado_obtenido: grado,
            litros_transferidos: agua,
            porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
            folio_documento: dilucionData.lote_agua || dilucionData.folio_documento || "",
            motivo: "Dilución pendiente de validación por UI",
            fecha: dilucionData.fecha || new Date().toISOString().split("T")[0],
            observaciones: dilucionData.observaciones || `Dilución con ${agua} L de agua. Grado proyectado: ${grado}%. En revisión UI.`,
            es_pendiente: true,
            estado_ui: "Pendiente UI"
          };

          return {
            ...rec,
            estatus: "revision",
            status: "revision",
            statusUI: "revision",
            tieneDilucionPendiente: true,
            dilucionPendiente: newMov,
            movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])],
            observaciones: `${rec.observaciones || ""} | [SOLICITUD DILUCIÓN PENDIENTE UI]: Incorporación solicitada de ${agua} L agua. Grado proyectado: ${grado}% Alc. Vol.`
          };
        }
        return rec;
      });
    });

    if (idLogin) {
      dispatch(registrarDilucionGranel({ ...dilucionData, id_login: idLogin })).then(res => {
        if (res?.meta?.requestStatus === "fulfilled") {
          dispatch(obtenerGranelesPorLogin(idLogin));
        }
      });
    }
  };

  // Manejador para Salida o Baja de Producto
  const handleSaveBaja = (bajaData) => {
    if (!bajaData) return;
    const vol = parseFloat(bajaData.litros_baja || bajaData.volumen || 0);

    setCustomGranelRecords(prev => {
      return prev.map(rec => {
        if (rec.id === bajaData.id_granel_origen || rec.noLote === bajaData.no_lote_origen) {
          const newMov = {
            id_movimiento: Date.now(),
            tipo_movimiento: "baja",
            litros_transferidos: vol,
            porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
            folio_documento: bajaData.folio_documento || "",
            motivo: `Baja/Egreso pendiente de validación por UI: ${bajaData.motivo || "Merma"}`,
            fecha: bajaData.fecha || new Date().toISOString().split("T")[0],
            observaciones: bajaData.observaciones || `Solicitud de baja de ${vol} L por motivo: ${bajaData.motivo}. En espera de validación UI.`,
            es_pendiente: true,
            estado_ui: "Pendiente UI"
          };

          return {
            ...rec,
            estatus: "revision",
            status: "revision",
            statusUI: "revision",
            tieneBajaPendiente: true,
            bajaPendiente: newMov,
            movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])],
            observaciones: `${rec.observaciones || ""} | [SOLICITUD BAJA PENDIENTE UI]: Solicitud de baja de ${vol} L por motivo: ${bajaData.motivo}.`
          };
        }
        return rec;
      });
    });

    if (idLogin) {
      dispatch(registrarBajaGranel({ ...bajaData, id_login: idLogin })).then(res => {
        if (res?.meta?.requestStatus === "fulfilled") {
          dispatch(obtenerGranelesPorLogin(idLogin));
        }
      });
    }
  };

  // Manejador para Salida a Muestreo
  const handleSaveMuestreo = (muestreoData) => {
    if (!muestreoData) return;
    const vol = parseFloat(muestreoData.litros_muestra || muestreoData.volumen || 0);

    setCustomGranelRecords(prev => {
      return prev.map(rec => {
        if (rec.id === muestreoData.id_granel_origen || rec.noLote === muestreoData.no_lote_origen) {
          const newMov = {
            id_movimiento: Date.now(),
            tipo_movimiento: "muestreo",
            litros_transferidos: vol,
            porcentaje_alc_vol: parseFloat(rec.porcentaje_alc_vol || 0),
            folio_documento: muestreoData.folio_documento || "",
            motivo: `Muestreo pendiente de validación por UI: ${muestreoData.tipo_muestreo || "Muestreo Oficial"}`,
            fecha: muestreoData.fecha || new Date().toISOString().split("T")[0],
            observaciones: muestreoData.observaciones || `Extracción de muestra de ${vol} L para ${muestreoData.tipo_muestreo}. En espera de validación UI.`,
            es_pendiente: true,
            estado_ui: "Pendiente UI"
          };

          return {
            ...rec,
            estatus: "revision",
            status: "revision",
            statusUI: "revision",
            tieneMuestreoPendiente: true,
            muestreoPendiente: newMov,
            movimientos: [newMov, ...(Array.isArray(rec.movimientos) ? rec.movimientos : [])],
            observaciones: `${rec.observaciones || ""} | [SOLICITUD MUESTREO PENDIENTE UI]: Solicitud de muestra de ${vol} L para ${muestreoData.tipo_muestreo}.`
          };
        }
        return rec;
      });
    });

    if (idLogin) {
      dispatch(registrarMuestreoGranel({ ...muestreoData, id_login: idLogin })).then(res => {
        if (res?.meta?.requestStatus === "fulfilled") {
          dispatch(obtenerGranelesPorLogin(idLogin));
        }
      });
    }
  };

  const handleCancelCoccion = (rec) => {
    Swal.fire({
      title: "¿Desea cancelar esta bitácora?",
      text: `La bitácora de producción "${rec.noProduccion || rec.id}" pasará a estatus CANCELADA.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DC2626",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Sí, cancelar bitácora",
      cancelButtonText: "No, volver"
    }).then((result) => {
      if (result.isConfirmed) {
        const idCoccion = rec.rawId || rec.idBitacoraCoccion || (typeof rec.id === 'number' ? rec.id : null);
        if (idCoccion) {
          dispatch(actualizarCoccion({ id: idCoccion, coccionData: { estatus: "cancelada" } }))
            .then(() => {
              if (idLogin) {
                dispatch(obtenerCoccionesPorLogin(idLogin));
                dispatch(obtenerTrazabilidadAsociado(idLogin));
              }
              Swal.fire({
                title: "Bitácora Cancelada",
                text: "El registro ha sido marcado como cancelado exitosamente.",
                icon: "success",
                confirmButtonColor: "#4A5D23"
              });
            })
            .catch((err) => {
              Swal.fire("Error", err?.message || "No se pudo cancelar el registro.", "error");
            });
        } else {
          setProductionLots(prev => prev.map(l => (l.id === rec.id || l.noProduccion === rec.noProduccion) ? { ...l, statusUI: "cancelado", status: "cancelada" } : l));
          Swal.fire("Cancelada", "La bitácora local ha sido cancelada.", "success");
        }
      }
    });
  };

  const handleOpenModalDocs = (lot) => {
    setSelectedLot(lot);
    setActiveModal("documentosCoccion");
  };

  const handleDocumentosUpdated = () => {
    if (userId) {
      dispatch(obtenerTrazabilidadAsociado(userId));
      dispatch(obtenerCoccionesPorLogin(userId));
    }
  };

  const handleOpenTrazabilidad = (lot) => {
    setSelectedLot(lot);
    setActiveModal("trazabilidad");
  };

  // Handlers para las secciones adicionales (Clases, Maduración, Condiciones, Quejas)
  const handleSaveElaboracion = async (record) => {
    try {
      const isExisting = record.dbId || (record.id_bitacora_clases && !isNaN(Number(record.id_bitacora_clases))) || (typeof record.id === "number");
      const targetId = record.dbId || record.id_bitacora_clases || record.id;

      const payload = {
        ...record,
        id_login: idLogin
      };

      let resultAction;
      if (isExisting && targetId) {
        resultAction = await dispatch(actualizarClaseAsociado({ id: targetId, claseData: payload }));
      } else {
        resultAction = await dispatch(registrarClaseAsociado(payload));
      }

      if (resultAction?.error) {
        Swal.fire("Error", resultAction.payload || resultAction.error?.message || "No se pudo guardar el registro de clases", "error");
        return;
      }

      if (idLogin) {
        dispatch(obtenerClasesPorLogin(idLogin));
      }

      setIsSectionFormOpen(false);
      const isDraftSaved = (record.status === "borrador" || record.estatus === "borrador");
      Swal.fire({
        title: "¡Éxito!",
        text: isDraftSaved
          ? "Borrador de Elaboración de Clases guardado correctamente."
          : "Registro de Elaboración de Clases enviado a revisión oficial exitosamente.",
        icon: "success",
        confirmButtonColor: "#2563EB"
      });
    } catch (err) {
      console.error("Error al guardar clase:", err);
      Swal.fire("Error", "Ocurrió un error inesperado al guardar la clase", "error");
    }
  };

  const handleSaveMaduracion = async (record) => {
    try {
      const isExisting = record.dbId || (record.id_bitacora_maduracion && !isNaN(Number(record.id_bitacora_maduracion))) || (typeof record.id === "number");
      const targetId = record.dbId || record.id_bitacora_maduracion || record.id;

      const payload = {
        ...record,
        id_login: idLogin
      };

      let resultAction;
      if (isExisting && targetId) {
        resultAction = await dispatch(actualizarMaduracionAsociado({ id: targetId, maduracionData: payload }));
      } else {
        resultAction = await dispatch(registrarMaduracionAsociado(payload));
      }

      if (resultAction?.error) {
        Swal.fire("Error", resultAction.payload || resultAction.error?.message || "No se pudo guardar el registro de maduración", "error");
        return;
      }

      if (idLogin) {
        dispatch(obtenerMaduracionPorLogin(idLogin));
        dispatch(obtenerGranelesPorLogin(idLogin));
      }

      setIsSectionFormOpen(false);
      if (!record.fecha_salida_maduracion) {
        Swal.fire({
          title: "¡Éxito!",
          text: "Registro de Maduración (Sección VII) guardado correctamente.",
          icon: "success",
          confirmButtonColor: "#D97706"
        });
      }
    } catch (err) {
      console.error("Error al guardar maduración:", err);
      Swal.fire("Error", "Ocurrió un error inesperado al guardar la maduración", "error");
    }
  };

  const handleDeleteMaduracion = async (record) => {
    const id = record.dbId || record.id_bitacora_maduracion || record.id;
    if (!id) return;

    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Se eliminará el registro de maduración del lote ${record.noLote || record.lote_maduracion || ""}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#EF4444",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar"
    });

    if (result.isConfirmed) {
      try {
        const resAction = await dispatch(eliminarMaduracionAsociado(id));
        if (resAction?.error) {
          Swal.fire("Error", resAction.payload || "No se pudo eliminar el registro de maduración", "error");
        } else {
          Swal.fire("Eliminado", "Registro de maduración eliminado con éxito", "success");
          if (idLogin) {
            dispatch(obtenerMaduracionPorLogin(idLogin));
            dispatch(obtenerGranelesPorLogin(idLogin));
          }
        }
      } catch (err) {
        console.error("Error al eliminar maduración:", err);
        Swal.fire("Error", "Ocurrió un error inesperado al eliminar el registro", "error");
      }
    }
  };

  const handleSaveCondiciones = async (record) => {
    try {
      const isExisting = record.dbId || (record.id_bitacora_condiciones && !isNaN(Number(record.id_bitacora_condiciones))) || (typeof record.id === "number");
      const targetId = record.dbId || record.id_bitacora_condiciones || record.id;

      const payload = {
        ...record,
        id_login: idLogin
      };

      let resultAction;
      if (isExisting && targetId) {
        resultAction = await dispatch(actualizarCondicionesAsociado({ id: targetId, condicionesData: payload }));
      } else {
        resultAction = await dispatch(registrarCondicionesAsociado(payload));
      }

      if (resultAction?.error) {
        Swal.fire("Error", resultAction.payload || resultAction.error?.message || "No se pudo guardar el registro de condiciones ambientales", "error");
        return;
      }

      if (idLogin) {
        dispatch(obtenerCondicionesPorLogin(idLogin));
      }

      setIsSectionFormOpen(false);
      Swal.fire({
        title: "¡Éxito!",
        text: "Registro de Condiciones Ambientales guardado correctamente.",
        icon: "success",
        confirmButtonColor: "#2563EB"
      });
    } catch (err) {
      console.error("Error al guardar condiciones:", err);
      Swal.fire("Error", "Ocurrió un error inesperado al guardar las condiciones ambientales", "error");
    }
  };

  const handleReloadCondiciones = useCallback(() => {
    if (idLogin) {
      dispatch(obtenerCondicionesPorLogin(idLogin));
    }
  }, [dispatch, idLogin]);

  const handleSaveQueja = (record) => {
    setQuejasRecords(prev => {
      const exists = prev.some(r => r.id && r.id === record.id);
      return exists ? prev.map(r => r.id === record.id ? record : r) : [record, ...prev];
    });
    setIsSectionFormOpen(false);
    Swal.fire("Éxito", "Registro de Queja guardado correctamente.", "success");
  };

  // ===================================
  // HELPERS VISUALES PARA LA TABLA
  // ===================================

  const getStageBadge = (stage) => {
    switch (stage) {
      case "coccion":
        return (
          <span className="stage-pill pill-coccion">
            <LocalFireDepartmentIcon style={{ fontSize: 16 }} />
            Cocción (Secc. II)
          </span>
        );
      case "molienda":
        return (
          <span className="stage-pill pill-molienda">
            <ScienceIcon style={{ fontSize: 16 }} />
            Molienda & Fermentación
          </span>
        );
      case "destilacion":
        return (
          <span className="stage-pill pill-destilacion">
            <WineBarIcon style={{ fontSize: 16 }} />
            2da Destilación
          </span>
        );
      case "granel":
        return (
          <span className="stage-pill pill-granel">
            <CheckCircleIcon style={{ fontSize: 16 }} />
            Granel / Concluido
          </span>
        );
      default:
        return <span className="stage-pill">{stage}</span>;
    }
  };

  const getStatusBadge = (status) => {
    const st = String(status || "").toLowerCase().trim();
    if (st === "aprobado" || st === "aprobado_ui" || st === "aceptada" || st === "aceptado") {
      return (
        <span className="status-pill pill-aprobado">
          <VerifiedIcon style={{ fontSize: 15 }} />
          Aceptada por UI
        </span>
      );
    }
    if (st === "rechazado" || st === "rechazada" || st === "rechazado_ui") {
      return (
        <span className="status-pill pill-rechazado">
          <ReportProblemIcon style={{ fontSize: 15 }} />
          Rechazada (Observaciones)
        </span>
      );
    }
    if (st === "revision" || st === "en_revision" || st === "enviada" || st === "nueva" || st === "pendiente_ui") {
      return (
        <span className="status-pill pill-pendiente">
          <PendingActionsIcon style={{ fontSize: 15 }} />
          {st === "en_revision" || st === "revision" ? "En Revisión UI" : "Enviada a UI"}
        </span>
      );
    }
    if (st === "borrador") {
      return (
        <span className="status-pill" style={{ background: "#F3F4F6", color: "#4B5563", border: "1px solid #E5E7EB", display: "inline-flex", alignItems: "center", gap: "4px", padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: 600 }}>
          <HourglassBottomIcon style={{ fontSize: 15 }} />
          Borrador
        </span>
      );
    }
    if (st === "cancelada" || st === "cancelado") {
      return (
        <span className="status-pill" style={{ background: "#F1F5F9", color: "#64748B", border: "1px solid #CBD5E1", display: "inline-flex", alignItems: "center", gap: "4px", padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: 600 }}>
          <CloseIcon style={{ fontSize: 15 }} />
          Cancelada
        </span>
      );
    }
    return <span className="status-pill">{status}</span>;
  };

  const getStageMetricSummary = (lot) => {
    switch (lot.etapaActual) {
      case "coccion":
        return (
          <div className="metric-cell">
            <div className="metric-main">
              <strong>{lot.coccion?.kgMagueyCocido?.toLocaleString() || 0} kg</strong>
              <span>cocidos</span>
            </div>
            <div className="metric-sub">
              {lot.coccion?.numPinas || 0} piñas • {lot.coccion?.pctArt || 0}% ART
            </div>
          </div>
        );
      case "molienda":
        return (
          <div className="metric-cell">
            <div className="metric-main">
              <strong>{lot.molienda?.totalVolOrdinario?.toLocaleString() || 0} L</strong>
              <span>1ra dest.</span>
            </div>
            <div className="metric-sub">
              {lot.molienda?.items?.length || 0} tinas • {lot.molienda?.totalVolFormulado?.toLocaleString() || 0} L form.
            </div>
          </div>
        );
      case "destilacion":
        return (
          <div className="metric-cell">
            <div className="metric-main">
              <strong style={{ color: "#7C3AED" }}>{lot.destilacion?.totalMezcalObtenido?.toLocaleString() || 0} L</strong>
              <span>Mezcal</span>
            </div>
            <div className="metric-sub">
              Grad. {lot.destilacion?.avgAlcMezcal || 0}% Alc. • {lot.destilacion?.items?.length || 0} alambiques
            </div>
          </div>
        );
      case "granel":
        return (
          <div className="metric-cell">
            <div className="metric-main">
              <strong style={{ color: "#059669" }}>{lot.granel?.volFinal?.toLocaleString() || 0} L</strong>
              <span>en {lot.granel?.idContenedor || 'Contenedor'}</span>
            </div>
            <div className="metric-sub">
              {lot.granel?.clase || 'Joven'} • {lot.granel?.alcFinal || 0}% Alc.
            </div>
          </div>
        );
      default:
        return <span>-</span>;
    }
  };

  return (
    <div className=" container2">
      {/* Background glow effects */}
      <div className="glow-blob glow-1"></div>
      <div className="glow-blob glow-2"></div>

      {/* =========================================================
          ENCABEZADO PRINCIPAL DE LA BITÁCORA DE PRODUCCIÓN
      ========================================================= */}
      <header className="main-trace-header">
        <div className="header-branding">
          <div className="header-icon-box">
            <LayersIcon style={{ fontSize: 32 }} />
          </div>
          <div>
            <div className="header-tag">COMERCAM • CONTROL DE PRODUCCIÓN</div>
            <h1>Bitácora de Producción</h1>
            <p>Registro y trazabilidad continua: Cocción → Molienda & Fermentación → Destilación → Granel</p>
          </div>
        </div>
      </header>

      {/* =========================================================
          BARRA DE PESTAÑAS (TABS SEGMENTADOS COMPACTOS)
      ========================================================= */}
      <div className="tabs-nav-bar-container">
        <div className="segmented-pill-container">
          {TABS_CONFIG.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                className={`segmented-pill-btn ${isActive ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab.id);
                  setIsSectionFormOpen(false);
                  if (idLogin) {
                    if (tab.id === 7) dispatch(obtenerCondicionesPorLogin(idLogin));
                    if (tab.id === 6) dispatch(obtenerMaduracionPorLogin(idLogin));
                    if (tab.id === 5) dispatch(obtenerClasesPorLogin(idLogin));
                    if (tab.id === 4) dispatch(obtenerGranelesPorLogin(idLogin));
                  }
                }}
              >
                <Icon style={{ fontSize: 16 }} />
                <span>{tab.shortLabel}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* =========================================================================
          CONTENIDO SEGÚN LA PESTAÑA SELECCIONADA
      ========================================================================= */}

      {/* ================= PESTAÑA 0: TRAZABILIDAD INTEGRAL (TABLA UNIFICADA) ================= */}
      {activeTab === 0 && (
        <div className="animate-fadeIn">
          {/* BARRA DE HERRAMIENTAS: BÚSQUEDA Y FILTROS */}
          <section className="control-bar-wrapper">
            <div className="search-box">
              <SearchIcon className="search-icon" />
              <input
                type="text"
                placeholder="Buscar por lote, especie de maguey, predio, inspector..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setTracePage(1);
                }}
              />
              {searchTerm && (
                <button
                  className="clear-search-btn"
                  onClick={() => {
                    setSearchTerm("");
                    setTracePage(1);
                  }}
                >
                  <CloseIcon style={{ fontSize: 16 }} />
                </button>
              )}
            </div>

            <div className="filter-group">
              <div className="filter-select-wrapper">
                <FilterListIcon className="filter-icon" />
                <select
                  value={selectedStatusFilter}
                  onChange={(e) => {
                    setSelectedStatusFilter(e.target.value);
                    setTracePage(1);
                  }}
                >
                  <option value="todos">Todos los Estatus</option>
                  <option value="borrador">Borradores</option>
                  <option value="enviada">Enviadas / En Revisión</option>
                  <option value="aprobado">Aceptadas por UI</option>
                  <option value="rechazado">Rechazadas / Con Observaciones</option>
                  <option value="cancelado">Canceladas</option>
                </select>
              </div>

              {(searchTerm || selectedStageFilter !== "todas" || selectedStatusFilter !== "todos") && (
                <button
                  className="btn-reset-filters"
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedStageFilter("todas");
                    setSelectedStatusFilter("todos");
                    setTracePage(1);
                  }}
                >
                  Limpiar Filtros
                </button>
              )}
            </div>
          </section>

          {/* TABLA ÚNICA DE TRAZABILIDAD DE PRODUCCIÓN */}
          <section className="table-responsive-card">
            <table className="traceability-table">
              <thead>
                <tr>
                  <th>No. Lote / Producción</th>
                  <th>Etapa Actual</th>
                  <th>Materia Prima</th>
                  <th>Métricas Clave</th>
                  <th>Línea de Vida</th>
                  <th>Dictamen UI</th>
                  <th style={{ textAlign: "center" }}>Acciones de Trazabilidad</th>
                </tr>
              </thead>
              <tbody>
                {filteredLots.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="empty-table-message">
                      <HelpOutlineIcon style={{ fontSize: 40, color: "#9CA3AF", marginBottom: 8 }} />
                      <p>No se encontraron registros de producción que coincidan con los filtros aplicados.</p>
                    </td>
                  </tr>
                ) : (
                  filteredLots.map((lot) => {
                    const isCoccion = lot.etapaActual === "coccion";
                    const isMolienda = lot.etapaActual === "molienda";
                    const isDestilacion = lot.etapaActual === "destilacion";
                    const isGranel = lot.etapaActual === "granel";
                    const rawSt = String(lot.statusUI || lot.status || lot.estatus || "").toLowerCase().trim();
                    const isAprobado = rawSt === "aprobado" || rawSt === "aprobado_ui" || rawSt === "aceptada" || rawSt === "aceptado";
                    const isCancelado = rawSt.includes("cancelad");

                    const stepNumber = isCoccion ? 1 : isMolienda ? 2 : isDestilacion ? 3 : 4;
                    const progressPct = (stepNumber / 4) * 100;

                    return (
                      <tr key={lot.id} className="lot-row">
                        {/* Columna 1: Folio e Identificación */}
                        <td>
                          <div className="lot-identification">
                            <span className="lot-number">{lot.noProduccion}</span>
                            <span className="lot-predio" title={lot.predio}>
                              {lot.predio}
                            </span>
                            <span className="lot-date">Inicio: {lot.fechaInicio}</span>
                          </div>
                        </td>

                        {/* Columna 2: Etapa Actual */}
                        <td>
                          {getStageBadge(lot.etapaActual)}
                        </td>

                        {/* Columna 3: Materia Prima */}
                        <td>
                          <div className="maguey-cell">
                            <div className="maguey-name" title={lot.tipoMaguey}>
                              <GrassIcon style={{ fontSize: 15, color: "#4A5D23" }} />
                              <span>{lot.tipoMaguey}</span>
                            </div>
                            <div className="maguey-weight">
                              {lot.coccion?.kgMagueyCrudo ? `${lot.coccion.kgMagueyCrudo.toLocaleString()} kg iniciales` : "-"}
                            </div>
                          </div>
                        </td>

                        {/* Columna 4: Métricas Clave de la etapa */}
                        <td>
                          {getStageMetricSummary(lot)}
                        </td>

                        {/* Columna 5: Stepper Visual de Avance */}
                        <td>
                          <div className="lifecycle-stepper">
                            <div className="progress-bar-bg">
                              <div
                                className="progress-bar-fill"
                                style={{ width: `${progressPct}%` }}
                              ></div>
                            </div>
                            <div className="stepper-dots">
                              <span className={`step-dot ${stepNumber >= 1 ? 'completed' : ''}`} title="1. Cocción">🔥</span>
                              <span className={`step-dot ${stepNumber >= 2 ? 'completed' : ''}`} title="2. Molienda & Fermentación">🧪</span>
                              <span className={`step-dot ${stepNumber >= 3 ? 'completed' : ''}`} title="3. Destilación">⚗️</span>
                              <span className={`step-dot ${stepNumber >= 4 ? 'completed' : ''}`} title="4. Granel">🍷</span>
                            </div>
                            <span className="stepper-text">Paso {stepNumber} de 4</span>
                          </div>
                        </td>

                        {/* Columna 6: Estatus UI e Inspector */}
                        <td>
                          <div className="inspector-cell">
                            {getStatusBadge(lot.statusUI)}
                            <span className="inspector-name" title={lot.inspector}>
                              {lot.inspector}
                            </span>
                            {lot.statusUI === "rechazado" && lot.observacionesInspector && (
                              <span className="inspector-note" title={lot.observacionesInspector} style={{ color: "#DC2626", fontWeight: 600 }}>
                                Rechazo UI: {lot.observacionesInspector}
                              </span>
                            )}
                          </div>
                        </td>

                        {/* Columna 7: Acciones Contextuales */}
                        <td>
                          <div className="action-buttons-cell">
                            {isCoccion && !isCancelado && (
                              <button
                                className="btn-next-stage btn-stage-molienda"
                                onClick={() => handleOpenMolienda(lot)}
                                title="Registrar Molienda & Fermentación para este lote"
                              >
                                <ScienceIcon style={{ fontSize: 16 }} />
                                <span>+ Molienda</span>
                              </button>
                            )}

                            {isMolienda && !isCancelado && (
                              <button
                                className="btn-next-stage btn-stage-destilacion"
                                onClick={() => handleOpenDestilacion(lot)}
                                title="Registrar 2da Destilación para este lote"
                              >
                                <WineBarIcon style={{ fontSize: 16 }} />
                                <span>+ Destilación</span>
                              </button>
                            )}

                            {isDestilacion && !isCancelado && (
                              <button
                                className="btn-next-stage btn-stage-granel"
                                onClick={() => handleOpenGranel(lot)}
                                title="Pasar producto a Inventario a Granel"
                              >
                                <Inventory2Icon style={{ fontSize: 16 }} />
                                <span>+ Granel</span>
                              </button>
                            )}

                            {isGranel && (
                              <span className="stage-completed-badge">
                                <VerifiedIcon style={{ fontSize: 16, color: "#10B981" }} />
                                <span>Concluido</span>
                              </span>
                            )}

                            <div className="secondary-actions-group">
                              <button
                                className="btn-icon-action btn-docs"
                                style={{
                                  backgroundColor: (lot.tiene_guia_maguey && lot.tiene_informe_art) ? "#ECFDF5" : (lot.tiene_guia_maguey || lot.tiene_informe_art) ? "#FFFBEB" : "#F0F9FF",
                                  color: (lot.tiene_guia_maguey && lot.tiene_informe_art) ? "#059669" : (lot.tiene_guia_maguey || lot.tiene_informe_art) ? "#D97706" : "#0284C7",
                                  border: `1px solid ${(lot.tiene_guia_maguey && lot.tiene_informe_art) ? "#A7F3D0" : (lot.tiene_guia_maguey || lot.tiene_informe_art) ? "#FDE68A" : "#BAE6FD"}`
                                }}
                                onClick={() => handleOpenModalDocs(lot)}
                                title={`Documentos de Cocción (${(lot.tiene_guia_maguey ? 1 : 0) + (lot.tiene_informe_art ? 1 : 0)}/2 cargados: Guía de Maguey e Informe ART)`}
                              >
                                <AttachFileIcon style={{ fontSize: 18 }} />
                              </button>
                              <button
                                className="btn-icon-action btn-trace"
                                onClick={() => handleOpenTrazabilidad(lot)}
                                title="Ver Trazabilidad Completa y Auditoría"
                              >
                                <TimelineIcon style={{ fontSize: 18 }} />
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </section>

          {/* CONTROLES DE PAGINACIÓN DE TRAZABILIDAD */}
          {(() => {
            const totalRecs = reduxTrazabilidadPagination?.total ?? filteredLots.length;
            const totalPages = reduxTrazabilidadPagination?.totalPages ?? Math.ceil(totalRecs / traceLimit) ?? 1;
            const currentPage = tracePage;

            if (totalRecs <= 0) return null;

            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "16px",
                  padding: "12px 18px",
                  background: "white",
                  borderRadius: "14px",
                  border: "1px solid var(--glass-border)",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                  flexWrap: "wrap",
                  gap: "12px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span style={{ fontSize: "13px", color: "var(--text-secondary)", fontWeight: 500 }}>
                    Mostrando página <strong>{currentPage}</strong> de <strong>{totalPages || 1}</strong> ({totalRecs} lotes en total)
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <button
                    disabled={currentPage <= 1}
                    onClick={() => setTracePage(prev => Math.max(1, prev - 1))}
                    className="btn-secondary-custom"
                    style={{
                      padding: "6px 14px",
                      fontSize: "12px",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: currentPage <= 1 ? "not-allowed" : "pointer",
                      opacity: currentPage <= 1 ? 0.45 : 1,
                      borderRadius: "8px",
                      border: "1px solid #D1D5DB",
                      backgroundColor: "white"
                    }}
                  >
                    <NavigateBeforeIcon style={{ fontSize: 18 }} /> Anterior
                  </button>

                  <span style={{ fontSize: "12.5px", fontWeight: 700, padding: "4px 10px", background: "#F3F4F6", borderRadius: "8px", color: "#374151" }}>
                    {currentPage} / {totalPages || 1}
                  </span>

                  <button
                    disabled={currentPage >= totalPages}
                    onClick={() => setTracePage(prev => (currentPage < totalPages ? prev + 1 : prev))}
                    className="btn-secondary-custom"
                    style={{
                      padding: "6px 14px",
                      fontSize: "12px",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: currentPage >= totalPages ? "not-allowed" : "pointer",
                      opacity: currentPage >= totalPages ? 0.45 : 1,
                      borderRadius: "8px",
                      border: "1px solid #D1D5DB",
                      backgroundColor: "white"
                    }}
                  >
                    Siguiente <NavigateNextIcon style={{ fontSize: 18 }} />
                  </button>
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {/* ================= PESTAÑA 1: SECCIÓN II - COCCIÓN ================= */}
      {activeTab === 1 && (
        <div className="animate-fadeIn section-tab-container">
          <CoccionSection
            coccionRecords={coccionSectionRecords}
            moliendaRecords={moliendaSectionRecords}
            onOpenNewMolienda={handleOpenNewMolienda}
            pagination={{
              currentPage: coccionPage,
              totalPages: reduxCoccionPagination?.totalPages || Math.ceil((reduxCoccionPagination?.total || coccionSectionRecords.length) / coccionLimit) || 1,
              totalRecords: reduxCoccionPagination?.total ?? coccionSectionRecords.length,
              limit: coccionLimit
            }}
            coccionSearch={coccionSearch}
            onSearchChange={(val) => {
              setCoccionSearch(val);
              setCoccionPage(1);
            }}
            onPageChange={(page) => setCoccionPage(page)}
            statusFilter={coccionStatusFilter}
            onStatusFilterChange={(st) => {
              setCoccionStatusFilter(st);
              setCoccionPage(1);
            }}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            magueySpecies={MAGUEY_SPECIES}
            catalogoMaguey={catalogoMaguey}
            handleSaveCoccion={handleSaveCoccion}
            handleCancelCoccion={handleCancelCoccion}
            onOpenNewCoccion={handleOpenNuevaCoccion}
            instalaciones={availableInstalaciones}
          />
        </div>
      )}

      {/* ================= PESTAÑA 2: SECCIÓN III (A) - MOLIENDA & FERMENTACIÓN ================= */}
      {activeTab === 2 && (
        <div className="animate-fadeIn section-tab-container">
          <MoliendaSection
            moliendaRecords={moliendaSectionRecords}
            coccionRecords={coccionSectionRecords}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            handleSaveMolienda={handleSaveMolienda}
            handleCancelMolienda={handleCancelMolienda}
            onOpenNewMolienda={handleOpenNewMolienda}
            onOpenNewDestilacion={handleOpenNewDestilacion}
            instalaciones={availableInstalaciones}
          />
        </div>
      )}

      {/* ================= PESTAÑA 3: SECCIÓN III (B) & IV - DESTILACIÓN ================= */}
      {activeTab === 3 && (
        <div className="animate-fadeIn section-tab-container">
          <DestilacionSection
            destilacionRecords={destilacionSectionRecords}
            moliendaRecords={moliendaSectionRecords}
            coccionRecords={coccionSectionRecords}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            handleSaveDestilacion={handleSaveDestilacion}
            handleCancelDestilacion={handleCancelDestilacion}
            onOpenNewDestilacion={handleOpenNewDestilacion}
            onOpenNewGranel={handleOpenGranel}
          />
        </div>
      )}

      {/* ================= PESTAÑA 4: SECCIÓN V - GRANEL ================= */}
      {activeTab === 4 && (
        <div className="animate-fadeIn section-tab-container">
          <GranelSection
            granelRecords={granelSectionRecords}
            destilacionRecords={destilacionSectionRecords}
            catalogoMaguey={catalogoMaguey}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            handleSaveGranel={handleSaveGranel}
            handleSaveFusion={handleSaveFusion}
            handleUndoGranel={handleUndoGranel}
            availableInstalaciones={availableInstalaciones}
            handleSaveTraslado={handleSaveTraslado}
            handleSaveDilucion={handleSaveDilucion}
            handleSaveBaja={handleSaveBaja}
            handleSaveMuestreo={handleSaveMuestreo}
          />
        </div>
      )}

      {/* ================= PESTAÑA 5: SECCIÓN VI - ELABORACIÓN CLASES / REPROCESOS ================= */}
      {activeTab === 5 && (
        <div className="animate-fadeIn section-tab-container">
          <ElaboracionSection
            elaboracionRecords={elaboracionRecords}
            granelRecords={granelSectionRecords}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            handleSaveElaboracion={handleSaveElaboracion}
          />
        </div>
      )}

      {/* ================= PESTAÑA 6: SECCIÓN VII - MADURACIÓN ================= */}
      {activeTab === 6 && (
        <div className="animate-fadeIn section-tab-container">
          <MaduracionSection
            maduracionRecords={effectiveMaduracionRecords}
            destilacionRecords={destilacionSectionRecords}
            granelRecords={granelSectionRecords}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            handleSaveMaduracion={handleSaveMaduracion}
            handleDeleteMaduracion={handleDeleteMaduracion}
          />
        </div>
      )}

      {/* ================= PESTAÑA 7: SECCIÓN VIII - CONDICIONES ================= */}
      {activeTab === 7 && (
        <div className="animate-fadeIn section-tab-container">
          <CondicionesSection
            condicionesRecords={effectiveCondicionesRecords}
            destilacionRecords={destilacionSectionRecords}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            handleSaveCondiciones={handleSaveCondiciones}
            onReloadCondiciones={handleReloadCondiciones}
          />
        </div>
      )}

      {/* ================= PESTAÑA 8: SECCIÓN IX - QUEJAS ================= */}
      {activeTab === 8 && (
        <div className="animate-fadeIn section-tab-container">
          <QuejasSection
            quejasRecords={quejasRecords}
            granelRecords={granelSectionRecords}
            isFormOpen={isSectionFormOpen}
            setIsFormOpen={setIsSectionFormOpen}
            formData={formSectionData}
            setFormData={setFormSectionData}
            handleSaveQueja={handleSaveQueja}
          />
        </div>
      )}

      {/* Modales 1, 2 y 3 unificados: CoccionSection, MoliendaSection y DestilacionSection son las fuentes únicas de verdad */}

      {/* Modal Granel unificado: GranelSection es la fuente única de verdad para Granel */}

      {/* =========================================================================
          MODAL 5: TRAZABILIDAD COMPLETA / AUDITORÍA INTEGRAL
      ========================================================================= */}
      {activeModal === "documentosCoccion" && selectedLot && (
        <ModalDocumentosCoccion
          isOpen={true}
          onClose={() => setActiveModal(null)}
          coccion={selectedLot}
          onDocumentUpdated={handleDocumentosUpdated}
        />
      )}

      {activeModal === "trazabilidad" && selectedLot && createPortal(
        <div className="modal-backdrop-custom">
          <div className="modal-dialog-custom modal-xl animate-scaleIn">
            <div className="modal-header-custom header-theme-trazabilidad">
              <div className="modal-header-title">
                <div className="icon-badge">
                  <TimelineIcon />
                </div>
                <div>
                  <h3>Expediente de Trazabilidad Integral</h3>
                  <p>Lote: <strong>{selectedLot.noProduccion}</strong> • {selectedLot.tipoMaguey}</p>
                </div>
              </div>
              <button className="modal-close-btn" onClick={() => setActiveModal(null)}>
                <CloseIcon />
              </button>
            </div>

            <div className="modal-body-scrollable">
              <div className="summary-banner-audit">
                <div className="audit-kpi">
                  <span className="label">Unidad de Producción:</span>
                  <strong>{selectedLot.unidadProduccion}</strong>
                </div>
                <div className="audit-kpi">
                  <span className="label">Predio & Guía:</span>
                  <strong>{selectedLot.predio}</strong>
                </div>
                <div className="audit-kpi">
                  <span className="label">Estatus Actual:</span>
                  <div>{getStatusBadge(selectedLot.statusUI)}</div>
                </div>
                <div className="audit-kpi">
                  <span className="label">Inspector Asignado:</span>
                  <strong>{selectedLot.inspector}</strong>
                </div>
              </div>

              <div className="audit-timeline">
                {/* FASE 1: COCCIÓN */}
                <div className={`timeline-card ${selectedLot.coccion ? 'active-step' : ''}`}>
                  <div className="timeline-node">
                    <LocalFireDepartmentIcon />
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-head">
                      <h4>1. Sección II: Cocción de Agave</h4>
                      <span className="badge-step-done">Completada</span>
                    </div>
                    {selectedLot.coccion && (
                      <div className="timeline-grid-3">
                        <div><strong>Ingreso:</strong> {selectedLot.coccion.fechaIngreso || '-'}</div>
                        <div><strong>Guía / Predio:</strong> {selectedLot.coccion.guiaPredio?.trim() || '-'}</div>
                        <div><strong>Especie Maguey:</strong> {selectedLot.tipoMaguey || '-'}</div>
                        <div><strong>Piñas:</strong> {selectedLot.coccion.numPinas || '-'}</div>
                        <div><strong>Kg Crudo:</strong> {selectedLot.coccion.kgMagueyCrudo ? `${selectedLot.coccion.kgMagueyCrudo.toLocaleString()} kg` : '-'}</div>
                        <div><strong>Kg Cocido:</strong> {selectedLot.coccion.kgMagueyCocido ? `${selectedLot.coccion.kgMagueyCocido.toLocaleString()} kg` : '-'}</div>
                        <div><strong>% ART:</strong> {selectedLot.coccion.pctArt != null ? `${selectedLot.coccion.pctArt}%` : 'N/A'}</div>
                        <div><strong>No. Informe:</strong> {selectedLot.coccion.noInforme || 'N/A'}</div>
                        <div><strong>Horno:</strong> {selectedLot.coccion.tipoHorno || '-'}</div>
                        <div><strong>Inicio Cocción:</strong> {selectedLot.coccion.fechaInicioCoccion || '-'}</div>
                        <div><strong>Fin Cocción:</strong> {selectedLot.coccion.fechaFinCoccion || '-'}</div>
                        <div style={{ gridColumn: "span 3" }}><strong>Observaciones:</strong> {selectedLot.coccion.observaciones || 'Sin observaciones.'}</div>
                      </div>
                    )}

                    {/* DOCUMENTOS ADJUNTOS DE COCCIÓN */}
                    <div style={{
                      marginTop: '12px',
                      padding: '10px 14px',
                      backgroundColor: '#F8FAF5',
                      border: '1px solid #D9E2C6',
                      borderRadius: '8px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '10px'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <span style={{ fontSize: '11.5px', fontWeight: 800, color: '#4A5D23', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          <AttachFileIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                          Documentos Adjuntos:
                        </span>

                        {/* Guía de Maguey */}
                        {selectedLot.tiene_guia_maguey ? (
                          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                            <a
                              href={`${hostUI}bitacora-produccion/coccion/${selectedLot.id_bitacora_coccion || selectedLot.dbId || selectedLot.id}/documentos/guia_maguey/ver`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm"
                              style={{
                                padding: '3px 9px',
                                fontSize: '11px',
                                fontWeight: 600,
                                backgroundColor: '#E8F5E9',
                                color: '#2E7D32',
                                border: '1px solid #A5D6A7',
                                borderRadius: '4px',
                                textDecoration: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '3px'
                              }}
                            >
                              <PictureAsPdfIcon style={{ fontSize: 14 }} /> Ver Guía de Maguey
                            </a>
                            <button
                              type="button"
                              onClick={() => {
                                handleOpenModalDocs(selectedLot);
                              }}
                              title="Reemplazar Guía de Maguey"
                              style={{
                                padding: '3px 6px',
                                fontSize: '11px',
                                backgroundColor: '#FFF',
                                color: '#4A5D23',
                                border: '1px solid #D9E2C6',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                            >
                              Reemplazar
                            </button>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              handleOpenModalDocs(selectedLot);
                            }}
                            style={{
                              padding: '3px 8px',
                              fontSize: '11px',
                              backgroundColor: '#FFF',
                              color: '#6B7280',
                              border: '1px dashed #D1D5DB',
                              borderRadius: '4px',
                              cursor: 'pointer'
                            }}
                          >
                            + Subir Guía de Maguey
                          </button>
                        )}

                        {/* Informe de ART */}
                        {selectedLot.tiene_informe_art ? (
                          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                            <a
                              href={`${hostUI}bitacora-produccion/coccion/${selectedLot.id_bitacora_coccion || selectedLot.dbId || selectedLot.id}/documentos/informe_art/ver`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm"
                              style={{
                                padding: '3px 9px',
                                fontSize: '11px',
                                fontWeight: 600,
                                backgroundColor: '#E3F2FD',
                                color: '#1565C0',
                                border: '1px solid #90CAF9',
                                borderRadius: '4px',
                                textDecoration: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '3px'
                              }}
                            >
                              <PictureAsPdfIcon style={{ fontSize: 14 }} /> Ver Informe ART
                            </a>
                            <button
                              type="button"
                              onClick={() => {
                                handleOpenModalDocs(selectedLot);
                              }}
                              title="Reemplazar Informe de ART"
                              style={{
                                padding: '3px 6px',
                                fontSize: '11px',
                                backgroundColor: '#FFF',
                                color: '#1565C0',
                                border: '1px solid #BBDEFB',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                            >
                              Reemplazar
                            </button>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              handleOpenModalDocs(selectedLot);
                            }}
                            style={{
                              padding: '3px 8px',
                              fontSize: '11px',
                              backgroundColor: '#FFF',
                              color: '#6B7280',
                              border: '1px dashed #D1D5DB',
                              borderRadius: '4px',
                              cursor: 'pointer'
                            }}
                          >
                            + Subir Informe ART
                          </button>
                        )}
                      </div>

                      <button
                        type="button"
                        onClick={() => {
                          handleOpenModalDocs(selectedLot);
                        }}
                        style={{
                          padding: '4px 12px',
                          fontSize: '11.5px',
                          fontWeight: 600,
                          backgroundColor: '#4A5D23',
                          color: '#FFF',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px'
                        }}
                      >
                        Gestionar Documentos
                      </button>
                    </div>

                  </div>
                </div>

                {/* FASE 2: MOLIENDA & FERMENTACIÓN */}
                <div className={`timeline-card ${selectedLot.molienda ? 'active-step' : 'pending-step'}`}>
                  <div className="timeline-node">
                    <ScienceIcon />
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-head">
                      <h4>2. Sección III (A): Molienda, Fermentación & 1ra Destilación</h4>
                      {selectedLot.molienda ? (
                        <span className="badge-step-done">Completada</span>
                      ) : (
                        <span className="badge-step-pending">En espera</span>
                      )}
                    </div>
                    {selectedLot.molienda ? (
                      <div>
                        <div className="timeline-grid-3">
                          <div><strong>Tipo Molienda:</strong> {selectedLot.molienda.tipoMolienda}</div>
                          <div><strong>Kg Procesados:</strong> {selectedLot.molienda.totalKgMaguey?.toLocaleString()} kg</div>
                          <div><strong>Vol. Formulado:</strong> {selectedLot.molienda.totalVolFormulado?.toLocaleString()} L</div>
                          <div><strong>Vol. Ordinario (1ra Dest):</strong> <span style={{ color: "#4A5D23", fontWeight: "bold" }}>{selectedLot.molienda.totalVolOrdinario?.toLocaleString()} L</span></div>
                          <div><strong>No. Tinas:</strong> {selectedLot.molienda.items?.length || 0}</div>
                        </div>

                        <div className="timeline-sublist">
                          <h5>Tinas de Fermentación Registradas:</h5>
                          {selectedLot.molienda.items?.map((it, idx) => (
                            <div key={idx} className="sublist-row">
                              <span>• {it.contenedor}</span>
                              <span>{it.kgMaguey} kg maguey</span>
                              <span>{it.volumenFormulado} L agua/mosto</span>
                              <strong>{it.volumenOrdinario} L ordinario ({it.pctAlcOrdinario}%)</strong>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <p className="step-empty-text">Etapa aún no registrada para este lote.</p>
                    )}
                  </div>
                </div>

                {/* FASE 3: DESTILACIÓN */}
                <div className={`timeline-card ${selectedLot.destilacion ? 'active-step' : 'pending-step'}`}>
                  <div className="timeline-node">
                    <WineBarIcon />
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-head">
                      <h4>3. Sección III (B) & IV: 2da Destilación (Refinado)</h4>
                      {selectedLot.destilacion ? (
                        <span className="badge-step-done">Completada</span>
                      ) : (
                        <span className="badge-step-pending">En espera</span>
                      )}
                    </div>
                    {selectedLot.destilacion ? (
                      <div>
                        <div className="timeline-grid-3">
                          <div><strong>Alambique:</strong> {selectedLot.destilacion.tipoAlambique}</div>
                          <div><strong>Carga Destilada:</strong> {selectedLot.destilacion.totalVolCargado?.toLocaleString()} L</div>
                          <div><strong>Puntas:</strong> {selectedLot.destilacion.totalPuntas} L</div>
                          <div><strong>Mezcal Corazón:</strong> <span style={{ color: "#7C3AED", fontWeight: "bold" }}>{selectedLot.destilacion.totalMezcalObtenido?.toLocaleString()} L</span></div>
                          <div><strong>Graduación Promedio:</strong> {selectedLot.destilacion.avgAlcMezcal}% Alc.</div>
                          <div><strong>Colas:</strong> {selectedLot.destilacion.totalColas} L</div>
                        </div>

                        <div className="timeline-sublist">
                          <h5>Corridas de Alambiques:</h5>
                          {selectedLot.destilacion.items?.map((it, idx) => (
                            <div key={idx} className="sublist-row">
                              <span>• {it.destiladorNum} ({it.fechaSegunda})</span>
                              <span>Carga: {it.volADestilar} L</span>
                              <strong>Mezcal: {it.mezcalVol} L ({it.mezcalAlc}%)</strong>
                              <span>Puntas: {it.puntasVol} L • Colas: {it.colasVol} L</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <p className="step-empty-text">Etapa aún no registrada para este lote.</p>
                    )}
                  </div>
                </div>

                {/* FASE 4: GRANEL */}
                <div className={`timeline-card ${selectedLot.granel ? 'active-step' : 'pending-step'}`}>
                  <div className="timeline-node">
                    <CheckCircleIcon />
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-head">
                      <h4>4. Sección V: Cierre e Inventario a Granel</h4>
                      {selectedLot.granel ? (
                        <span className="badge-step-done">Completada</span>
                      ) : (
                        <span className="badge-step-pending">En espera</span>
                      )}
                    </div>
                    {selectedLot.granel ? (
                      <div className="timeline-grid-3">
                        <div><strong>Contenedor Destino:</strong> {selectedLot.granel.idContenedor}</div>
                        <div><strong>Categoría & Clase:</strong> {selectedLot.granel.categoria} - {selectedLot.granel.clase}</div>
                        <div><strong>No. Análisis:</strong> {selectedLot.granel.noAnalisis}</div>
                        <div><strong>Volumen Final:</strong> <span style={{ color: "#059669", fontWeight: "bold" }}>{selectedLot.granel.volFinal?.toLocaleString()} L</span></div>
                        <div><strong>Graduación Final:</strong> {selectedLot.granel.alcFinal}% Alc.</div>
                        <div><strong>Ajuste de Agua:</strong> {selectedLot.granel.volAguaAjuste} L</div>
                      </div>
                    ) : (
                      <p className="step-empty-text">Etapa de inventario a granel pendiente.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer-custom">
              <button type="button" className="btn-cancel-modal" onClick={() => setActiveModal(null)}>
                Cerrar Expediente
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default BitacoraProduccion;